var _filter, _linearGradient, _filter2, _linearGradient2, _filter3, _linearGradient3, _filter4, _linearGradient4, _filter5, _linearGradient5, _filter6, _linearGradient6, _filter7, _linearGradient7, _filter8, _linearGradient8, _filter9, _linearGradient9, _filter0, _linearGradient0, _filter1, _linearGradient1, _linearGradient10, _filter10, _linearGradient11, _filter11, _linearGradient12, _filter12, _linearGradient13, _filter13, _linearGradient14, _linearGradient15, _filter14, _linearGradient16, _filter15, _linearGradient17, _linearGradient18, _linearGradient19, _filter16, _linearGradient20, _filter17, _linearGradient21, _filter18, _linearGradient22, _filter19, _linearGradient23, _filter20, _linearGradient24, _filter21, _linearGradient25, _linearGradient26, _filter22, _linearGradient27, _filter23, _linearGradient28, _filter24, _linearGradient29, _filter25, _linearGradient30, _filter26, _linearGradient31, _filter27, _linearGradient32, _filter28, _linearGradient33, _filter29, _linearGradient34, _filter30, _linearGradient35, _filter31, _linearGradient36, _linearGradient37, _filter32, _linearGradient38, _filter33, _linearGradient39, _filter34, _linearGradient40, _filter35, _linearGradient41, _filter36, _linearGradient42, _filter37, _linearGradient43, _filter38, _linearGradient44, _filter39, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _filter40, _filter41, _linearGradient59, _filter42, _linearGradient60, _filter43, _linearGradient61, _filter44, _linearGradient62, _filter45, _linearGradient63, _filter46, _linearGradient64, _filter47, _linearGradient65, _filter48, _linearGradient66, _filter49, _linearGradient67, _filter50, _linearGradient68, _filter51, _linearGradient69, _filter52, _linearGradient70, _filter53, _linearGradient71, _filter54, _linearGradient72, _filter55, _linearGradient73, _filter56, _linearGradient74, _filter57, _linearGradient75, _filter58, _linearGradient76, _filter59, _linearGradient77, _filter60, _linearGradient78, _filter61, _linearGradient79, _filter62, _linearGradient80, _filter63, _linearGradient81, _filter64, _linearGradient82, _filter65, _linearGradient83, _filter66, _linearGradient84, _filter67, _linearGradient85, _filter68, _linearGradient86, _filter69, _linearGradient87, _filter70, _linearGradient88, _filter71, _linearGradient89, _filter72, _linearGradient90, _filter73, _linearGradient91, _filter74, _linearGradient92, _filter75, _linearGradient93, _filter76, _linearGradient94, _filter77, _linearGradient95, _filter78, _linearGradient96, _filter79, _linearGradient97, _filter80, _linearGradient98, _filter81, _linearGradient99, _filter82, _linearGradient100, _filter83, _linearGradient101, _filter84, _linearGradient102, _filter85, _linearGradient103, _filter86, _linearGradient104, _filter87, _linearGradient105, _filter88, _linearGradient106, _filter89, _linearGradient107, _filter90, _linearGradient108, _filter91, _linearGradient109, _filter92, _linearGradient110, _filter93, _linearGradient111, _filter94, _linearGradient112, _filter95, _linearGradient113, _linearGradient114, _filter96, _linearGradient115, _filter97, _linearGradient116, _linearGradient117, _linearGradient118, _linearGradient119, _linearGradient120, _linearGradient121, _linearGradient122, _linearGradient123, _linearGradient124, _linearGradient125, _linearGradient126, _filter98, _linearGradient127, _linearGradient128, _linearGradient129, _linearGradient130, _linearGradient131, _linearGradient132, _linearGradient133, _linearGradient134, _linearGradient135, _linearGradient136, _linearGradient137, _linearGradient138, _linearGradient139, _linearGradient140, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualifiedLeadBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 263.304,
    height: 227.967,
    viewBox: "0 0 263.304 227.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 101.912,
    y: -8565.051,
    width: 48.452,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 101.912,
    y: -8565.051,
    width: 48.452,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip)"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 126.138,
    y1: 165.578,
    x2: 126.138,
    y2: 203.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 123.231,
    y: -8565.051,
    width: 9.656,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 123.231,
    y: -8565.051,
    width: 9.656,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-2)"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 113.803,
    y1: 195.627,
    x2: 130.952,
    y2: 184.805,
    xlinkHref: "#linear-gradient"
  })), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 126.084,
    y: -8565.051,
    width: 5.5,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 126.084,
    y: -8565.051,
    width: 5.5,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-3)"
    }
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 113.493,
    y1: 200.596,
    x2: 134.563,
    y2: 201.905,
    xlinkHref: "#linear-gradient"
  })), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 124.995,
    y: -8565.051,
    width: 11.158,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 124.995,
    y: -8565.051,
    width: 11.158,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-4)"
    }
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 111.598,
    y1: 209.028,
    x2: 131.246,
    y2: 196.629,
    xlinkHref: "#linear-gradient"
  })), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 129.268,
    y: -8565.051,
    width: 8.302,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 129.268,
    y: -8565.051,
    width: 8.302,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-5)"
    }
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 122.454,
    y1: 209.884,
    x2: 133.136,
    y2: 200.537,
    xlinkHref: "#linear-gradient"
  })), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 126.552,
    y: -8565.051,
    width: 9.656,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 126.552,
    y: -8565.051,
    width: 9.656,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-6)"
    }
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 117.124,
    y1: 207.299,
    x2: 134.273,
    y2: 196.477,
    xlinkHref: "#linear-gradient"
  })), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 129.822,
    y: -8565.051,
    width: 5.451,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 129.822,
    y: -8565.051,
    width: 5.451,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-7)"
    }
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 126.707,
    y1: 199.933,
    x2: 134.683,
    y2: 194.9,
    xlinkHref: "#linear-gradient"
  })), _filter8 || (_filter8 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 127.892,
    y: -8565.051,
    width: 7.37,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 127.892,
    y: -8565.051,
    width: 7.37,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-8)"
    }
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 121.493,
    y1: 393.37,
    x2: 128.583,
    y2: 384.563,
    gradientTransform: "matrix(0.999, -0.043, 0.043, 0.999, -14.388, -179.229)",
    xlinkHref: "#linear-gradient"
  })), _filter9 || (_filter9 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 126.306,
    y: -8565.051,
    width: 43.664,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 126.306,
    y: -8565.051,
    width: 43.664,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-9)"
    }
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 155.88,
    y1: 542.807,
    x2: 155.324,
    y2: 541.825,
    gradientTransform: "translate(-57.824 -427.564) rotate(-5.975)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _filter0 || (_filter0 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 126.313,
    y: -8565.051,
    width: 43.664,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 126.313,
    y: -8565.051,
    width: 43.664,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-10)"
    }
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 144.033,
    y1: 546.615,
    x2: 144.713,
    y2: 545.447,
    xlinkHref: "#linear-gradient-9"
  })), _filter1 || (_filter1 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-11",
    x: 63.696,
    y: -8565.051,
    width: 50.688,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 63.696,
    y: -8565.051,
    width: 50.688,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-11)"
    }
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -8504.529,
    y1: -333.647,
    x2: -8505.219,
    y2: -334.865,
    gradientTransform: "matrix(-0.935, -0.168, -0.141, 0.984, -7918.502, -1056.686)",
    xlinkHref: "#linear-gradient-9"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -8519.233,
    y1: -328.924,
    x2: -8518.39,
    y2: -330.373,
    gradientTransform: "matrix(-0.935, -0.168, -0.141, 0.984, -7918.502, -1056.686)",
    xlinkHref: "#linear-gradient-9"
  })), _filter10 || (_filter10 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-13",
    x: 126.501,
    y: -8565.051,
    width: 5.451,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 126.501,
    y: -8565.051,
    width: 5.451,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-13)"
    }
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 123.386,
    y1: 188.262,
    x2: 131.362,
    y2: 183.228,
    xlinkHref: "#linear-gradient"
  })), _filter11 || (_filter11 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-14",
    x: 124.743,
    y: -8565.051,
    width: 6.439,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: 124.743,
    y: -8565.051,
    width: 6.439,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-14)"
    }
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 122.967,
    y1: 192.343,
    x2: 127.481,
    y2: 187.161,
    xlinkHref: "#linear-gradient"
  })), _filter12 || (_filter12 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-15",
    x: 122.763,
    y: -8565.051,
    width: 5.5,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: 122.763,
    y: -8565.051,
    width: 5.5,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-15)"
    }
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 110.172,
    y1: 186.772,
    x2: 131.243,
    y2: 188.081,
    xlinkHref: "#linear-gradient"
  })), _filter13 || (_filter13 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-16",
    x: 121.674,
    y: -8565.051,
    width: 11.158,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    x: 121.674,
    y: -8565.051,
    width: 11.158,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-16)"
    }
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 108.278,
    y1: 195.204,
    x2: 127.925,
    y2: 182.805,
    xlinkHref: "#linear-gradient"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 126.138,
    y1: 169.842,
    x2: 126.138,
    y2: 202.329,
    xlinkHref: "#linear-gradient"
  })), _filter14 || (_filter14 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-18",
    x: 125.947,
    y: -8565.051,
    width: 8.302,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    x: 125.947,
    y: -8565.051,
    width: 8.302,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-18)"
    }
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 119.133,
    y1: 196.06,
    x2: 129.815,
    y2: 186.713,
    xlinkHref: "#linear-gradient"
  })), _filter15 || (_filter15 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-19",
    x: 123.231,
    y: -8565.051,
    width: 9.655,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    x: 123.231,
    y: -8565.051,
    width: 9.655,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-19)"
    }
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 113.803,
    y1: 193.475,
    x2: 130.952,
    y2: 182.653,
    xlinkHref: "#linear-gradient"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 123.386,
    y1: 186.109,
    x2: 131.362,
    y2: 181.076,
    xlinkHref: "#linear-gradient"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 122.967,
    y1: 190.191,
    x2: 127.481,
    y2: 185.009,
    xlinkHref: "#linear-gradient"
  })), _filter16 || (_filter16 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-22",
    x: 122.725,
    y: -8565.051,
    width: 5.5,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    x: 122.725,
    y: -8565.051,
    width: 5.5,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-22)"
    }
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 110.133,
    y1: 184.636,
    x2: 131.204,
    y2: 185.945,
    xlinkHref: "#linear-gradient"
  })), _filter17 || (_filter17 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-23",
    x: 121.636,
    y: -8565.051,
    width: 11.158,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    x: 121.636,
    y: -8565.051,
    width: 11.158,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-23)"
    }
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 108.239,
    y1: 193.068,
    x2: 127.887,
    y2: 180.67,
    xlinkHref: "#linear-gradient"
  })), _filter18 || (_filter18 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-24",
    x: 125.909,
    y: -8565.051,
    width: 8.302,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    x: 125.909,
    y: -8565.051,
    width: 8.302,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-24)"
    }
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 119.095,
    y1: 193.924,
    x2: 129.777,
    y2: 184.577,
    xlinkHref: "#linear-gradient"
  })), _filter19 || (_filter19 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-25",
    x: 123.192,
    y: -8565.051,
    width: 9.656,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    x: 123.192,
    y: -8565.051,
    width: 9.656,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-25)"
    }
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 113.765,
    y1: 191.339,
    x2: 130.913,
    y2: 180.517,
    xlinkHref: "#linear-gradient"
  })), _filter20 || (_filter20 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-26",
    x: 126.463,
    y: -8565.051,
    width: 5.451,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    x: 126.463,
    y: -8565.051,
    width: 5.451,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-26)"
    }
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 123.348,
    y1: 183.974,
    x2: 131.324,
    y2: 178.94,
    xlinkHref: "#linear-gradient"
  })), _filter21 || (_filter21 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-27",
    x: 124.704,
    y: -8565.051,
    width: 6.439,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-27",
    x: 124.704,
    y: -8565.051,
    width: 6.439,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-27)"
    }
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 122.928,
    y1: 188.055,
    x2: 127.443,
    y2: 182.873,
    xlinkHref: "#linear-gradient"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 110.172,
    y1: 188.924,
    x2: 131.243,
    y2: 190.233,
    xlinkHref: "#linear-gradient"
  })), _filter22 || (_filter22 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-29",
    x: 122.738,
    y: -8565.051,
    width: 5.5,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-29",
    x: 122.738,
    y: -8565.051,
    width: 5.5,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-29)"
    }
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 110.147,
    y1: 182.558,
    x2: 131.217,
    y2: 183.867,
    xlinkHref: "#linear-gradient"
  })), _filter23 || (_filter23 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-30",
    x: 121.649,
    y: -8565.051,
    width: 11.158,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    x: 121.649,
    y: -8565.051,
    width: 11.158,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-30)"
    }
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 108.252,
    y1: 190.99,
    x2: 127.9,
    y2: 178.591,
    xlinkHref: "#linear-gradient"
  })), _filter24 || (_filter24 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-31",
    x: 125.922,
    y: -8565.051,
    width: 8.302,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    x: 125.922,
    y: -8565.051,
    width: 8.302,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-31)"
    }
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 119.108,
    y1: 191.846,
    x2: 129.79,
    y2: 182.499,
    xlinkHref: "#linear-gradient"
  })), _filter25 || (_filter25 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-32",
    x: 123.205,
    y: -8565.051,
    width: 9.656,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    x: 123.205,
    y: -8565.051,
    width: 9.656,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-32)"
    }
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 113.778,
    y1: 189.261,
    x2: 130.926,
    y2: 178.439,
    xlinkHref: "#linear-gradient"
  })), _filter26 || (_filter26 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-33",
    x: 126.476,
    y: -8565.051,
    width: 5.451,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-33",
    x: 126.476,
    y: -8565.051,
    width: 5.451,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-33)"
    }
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 123.361,
    y1: 181.895,
    x2: 131.337,
    y2: 176.862,
    xlinkHref: "#linear-gradient"
  })), _filter27 || (_filter27 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-34",
    x: 124.717,
    y: -8565.051,
    width: 6.439,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    x: 124.717,
    y: -8565.051,
    width: 6.439,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-34)"
    }
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 122.942,
    y1: 185.977,
    x2: 127.456,
    y2: 180.795,
    xlinkHref: "#linear-gradient"
  })), _filter28 || (_filter28 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-35",
    x: 122.77,
    y: -8565.051,
    width: 5.5,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-35",
    x: 122.77,
    y: -8565.051,
    width: 5.5,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-35)"
    }
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 110.178,
    y1: 180.466,
    x2: 131.249,
    y2: 181.774,
    xlinkHref: "#linear-gradient"
  })), _filter29 || (_filter29 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-36",
    x: 121.681,
    y: -8565.051,
    width: 11.158,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-36",
    x: 121.681,
    y: -8565.051,
    width: 11.158,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-36)"
    }
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 108.284,
    y1: 188.898,
    x2: 127.932,
    y2: 176.499,
    xlinkHref: "#linear-gradient"
  })), _filter30 || (_filter30 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-37",
    x: 125.954,
    y: -8565.051,
    width: 8.302,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-37",
    x: 125.954,
    y: -8565.051,
    width: 8.302,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-37)"
    }
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 119.14,
    y1: 189.753,
    x2: 129.822,
    y2: 180.407,
    xlinkHref: "#linear-gradient"
  })), _filter31 || (_filter31 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-38",
    x: 123.237,
    y: -8565.051,
    width: 9.655,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-38",
    x: 123.237,
    y: -8565.051,
    width: 9.655,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-38)"
    }
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 113.81,
    y1: 187.169,
    x2: 130.958,
    y2: 176.347,
    xlinkHref: "#linear-gradient"
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 108.278,
    y1: 197.356,
    x2: 127.925,
    y2: 184.957,
    xlinkHref: "#linear-gradient"
  })), _filter32 || (_filter32 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-40",
    x: 126.508,
    y: -8565.051,
    width: 5.451,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-40",
    x: 126.508,
    y: -8565.051,
    width: 5.451,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-40)"
    }
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 123.393,
    y1: 179.803,
    x2: 131.369,
    y2: 174.77,
    xlinkHref: "#linear-gradient"
  })), _filter33 || (_filter33 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-41",
    x: 124.749,
    y: -8565.051,
    width: 6.439,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-41",
    x: 124.749,
    y: -8565.051,
    width: 6.439,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-41)"
    }
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 122.974,
    y1: 183.885,
    x2: 127.488,
    y2: 178.702,
    xlinkHref: "#linear-gradient"
  })), _filter34 || (_filter34 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-42",
    x: 114.182,
    y: -8565.051,
    width: 5.5,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-42",
    x: 114.182,
    y: -8565.051,
    width: 5.5,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-42)"
    }
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 101.591,
    y1: 197.363,
    x2: 122.662,
    y2: 198.671,
    xlinkHref: "#linear-gradient"
  })), _filter35 || (_filter35 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-43",
    x: 113.093,
    y: -8565.051,
    width: 11.158,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-43",
    x: 113.093,
    y: -8565.051,
    width: 11.158,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-43)"
    }
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 99.697,
    y1: 205.795,
    x2: 119.344,
    y2: 193.396,
    xlinkHref: "#linear-gradient"
  })), _filter36 || (_filter36 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-44",
    x: 117.366,
    y: -8565.051,
    width: 8.302,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-44",
    x: 117.366,
    y: -8565.051,
    width: 8.302,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-44)"
    }
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 110.552,
    y1: 206.65,
    x2: 121.234,
    y2: 197.304,
    xlinkHref: "#linear-gradient"
  })), _filter37 || (_filter37 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-45",
    x: 114.65,
    y: -8565.051,
    width: 9.656,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-45",
    x: 114.65,
    y: -8565.051,
    width: 9.656,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-45)"
    }
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 105.222,
    y1: 204.066,
    x2: 122.371,
    y2: 193.244,
    xlinkHref: "#linear-gradient"
  })), _filter38 || (_filter38 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-46",
    x: 117.92,
    y: -8565.051,
    width: 5.451,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-46",
    x: 117.92,
    y: -8565.051,
    width: 5.451,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-46)"
    }
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 114.805,
    y1: 196.7,
    x2: 122.781,
    y2: 191.667,
    xlinkHref: "#linear-gradient"
  })), _filter39 || (_filter39 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-47",
    x: 115.688,
    y: -8565.051,
    width: 7.579,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-47",
    x: 115.688,
    y: -8565.051,
    width: 7.579,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#luminosity-noclip-47)"
    }
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 112.407,
    y1: 204.343,
    x2: 118.88,
    y2: 195.541,
    xlinkHref: "#linear-gradient"
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 101.591,
    y1: 195.163,
    x2: 122.662,
    y2: 196.472,
    xlinkHref: "#linear-gradient"
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 99.697,
    y1: 203.595,
    x2: 119.344,
    y2: 191.197,
    xlinkHref: "#linear-gradient"
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 119.133,
    y1: 198.212,
    x2: 129.815,
    y2: 188.865,
    xlinkHref: "#linear-gradient"
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 110.552,
    y1: 204.451,
    x2: 121.234,
    y2: 195.104,
    xlinkHref: "#linear-gradient"
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 105.222,
    y1: 201.866,
    x2: 122.371,
    y2: 191.044,
    xlinkHref: "#linear-gradient"
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 114.805,
    y1: 194.501,
    x2: 122.781,
    y2: 189.467,
    xlinkHref: "#linear-gradient"
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 112.407,
    y1: 202.143,
    x2: 118.88,
    y2: 193.342,
    xlinkHref: "#linear-gradient"
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 101.591,
    y1: 192.964,
    x2: 122.662,
    y2: 194.272,
    xlinkHref: "#linear-gradient"
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 99.697,
    y1: 201.396,
    x2: 119.344,
    y2: 188.997,
    xlinkHref: "#linear-gradient"
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 110.552,
    y1: 202.251,
    x2: 121.234,
    y2: 192.905,
    xlinkHref: "#linear-gradient"
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 105.222,
    y1: 199.667,
    x2: 122.371,
    y2: 188.845,
    xlinkHref: "#linear-gradient"
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 114.805,
    y1: 192.301,
    x2: 122.781,
    y2: 187.268,
    xlinkHref: "#linear-gradient"
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 112.407,
    y1: 199.944,
    x2: 118.88,
    y2: 191.142,
    xlinkHref: "#linear-gradient"
  })), _filter40 || (_filter40 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-61",
    x: 101.912,
    y: 157.51,
    width: 48.452,
    height: 37.982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-61",
    x: 101.912,
    y: 157.51,
    width: 48.452,
    height: 37.982,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask)",
      filter: "url(#luminosity-noclip-61)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 157.51,
    width: 48.452,
    height: 37.982,
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient)"
    }
  }))), _filter41 || (_filter41 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-62",
    x: 101.912,
    y: 162.924,
    width: 48.452,
    height: 32.568,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-62",
    x: 101.912,
    y: 162.924,
    width: 48.452,
    height: 32.568,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask)",
      filter: "url(#luminosity-noclip-62)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.912,
    y: 162.924,
    width: 48.452,
    height: 32.568,
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-17)"
    }
  }))), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 126.138,
    y1: 169.842,
    x2: 126.138,
    y2: 202.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6ff"
  }))), _filter42 || (_filter42 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-63",
    x: 122.763,
    y: 187.92,
    width: 5.5,
    height: 3.886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-63",
    x: 122.763,
    y: 187.92,
    width: 5.5,
    height: 3.886,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-15)",
      filter: "url(#luminosity-noclip-63)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.763,187.92v2.185a8.072,8.072,0,0,0,5.5,1.7V190.5Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-28)"
    }
  }))), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 110.172,
    y1: 188.924,
    x2: 131.243,
    y2: 190.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d10b57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _filter43 || (_filter43 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-64",
    x: 121.674,
    y: 182.724,
    width: 11.158,
    height: 6.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-64",
    x: 121.674,
    y: 182.724,
    width: 11.158,
    height: 6.772,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-16)",
      filter: "url(#luminosity-noclip-64)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.763,189.5l9.07-5.343a8.2,8.2,0,0,0-4.854-1.429l-6.3,3.886A3.5,3.5,0,0,0,123.763,189.5Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-39)"
    }
  }))), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 108.278,
    y1: 197.356,
    x2: 127.925,
    y2: 184.957,
    xlinkHref: "#linear-gradient-62"
  })), _filter44 || (_filter44 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-65",
    x: 125.947,
    y: 185.571,
    width: 8.302,
    height: 4.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-65",
    x: 125.947,
    y: 185.571,
    width: 8.302,
    height: 4.925,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-18)",
      filter: "url(#luminosity-noclip-65)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.962,190.5c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.03-.361,2.536,2.536,0,0,0-.234-1.039c-2.732,1.6-5.8,3.393-8.069,4.718A9.885,9.885,0,0,0,127.962,190.5Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-50)"
    }
  }))), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 119.133,
    y1: 198.212,
    x2: 129.815,
    y2: 188.865,
    xlinkHref: "#linear-gradient-62"
  })), _filter45 || (_filter45 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-66",
    x: 123.231,
    y: 183.905,
    width: 9.656,
    height: 5.411,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-66",
    x: 123.231,
    y: 183.905,
    width: 9.656,
    height: 5.411,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-2)",
      filter: "url(#luminosity-noclip-66)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.01,189.316l5.876-3.462a3.277,3.277,0,0,0-1.847-1.717,9.77,9.77,0,0,0-2.124-.232l-5.684,3.5A5.043,5.043,0,0,0,127.01,189.316Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-2)"
    }
  }))), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 113.803,
    y1: 195.627,
    x2: 130.952,
    y2: 184.805,
    xlinkHref: "#linear-gradient-62"
  })), _filter46 || (_filter46 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-67",
    x: 126.501,
    y: 183.512,
    width: 5.451,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-67",
    x: 126.501,
    y: 183.512,
    width: 5.451,
    height: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-13)",
      filter: "url(#luminosity-noclip-67)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.97,183.512a8.375,8.375,0,0,0-1.469.128v.853a8.363,8.363,0,0,1,1.469-.13,6.709,6.709,0,0,1,3.98,1.149h0v-.852A6.731,6.731,0,0,0,127.97,183.512Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-13)"
    }
  }))), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 123.386,
    y1: 188.262,
    x2: 131.362,
    y2: 183.228,
    xlinkHref: "#linear-gradient-62"
  })), _filter47 || (_filter47 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-68",
    x: 124.743,
    y: 184.655,
    width: 6.439,
    height: 3.64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-68",
    x: 124.743,
    y: 184.655,
    width: 6.439,
    height: 3.64,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-14)",
      filter: "url(#luminosity-noclip-68)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.342,187.527l-1.367-.763a4.053,4.053,0,0,1-1.472.24,2.688,2.688,0,0,1-1.191-.327.932.932,0,0,1-.567-.7.882.882,0,0,1,.462-.76l-.323-.18.464-.277.323.18a2.9,2.9,0,0,1,1.163-.285,2.942,2.942,0,0,1,1.164.207l-.7.543a1.512,1.512,0,0,0-.906-.062l1.275.711a4.62,4.62,0,0,1,1.6-.317,2.5,2.5,0,0,1,1.144.318,1.088,1.088,0,0,1,.644.764.98.98,0,0,1-.478.858l.61.34-.464.277-.594-.331a3.171,3.171,0,0,1-1.319.3,3.658,3.658,0,0,1-1.436-.292l.743-.549a2.287,2.287,0,0,0,.642.137A2.157,2.157,0,0,0,129.342,187.527Zm-3.424-1.912a.316.316,0,0,0-.079.3.452.452,0,0,0,.233.26,1.052,1.052,0,0,0,.424.118,1.683,1.683,0,0,0,.55-.051Zm3.933,1.66a.388.388,0,0,0,.164-.359.481.481,0,0,0-.275-.327,1.109,1.109,0,0,0-.5-.135,1.837,1.837,0,0,0-.658.111Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-14)"
    }
  }))), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 122.967,
    y1: 192.343,
    x2: 127.481,
    y2: 187.161,
    xlinkHref: "#linear-gradient-62"
  })), _filter48 || (_filter48 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-69",
    x: 122.763,
    y: 185.768,
    width: 5.5,
    height: 3.886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-69",
    x: 122.763,
    y: 185.768,
    width: 5.5,
    height: 3.886,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-15)",
      filter: "url(#luminosity-noclip-69)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.763,185.768v2.185a8.072,8.072,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-15)"
    }
  }))), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 110.172,
    y1: 186.772,
    x2: 131.243,
    y2: 188.081,
    xlinkHref: "#linear-gradient-62"
  })), _filter49 || (_filter49 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-70",
    x: 121.674,
    y: 180.572,
    width: 11.158,
    height: 6.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-70",
    x: 121.674,
    y: 180.572,
    width: 11.158,
    height: 6.772,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-16)",
      filter: "url(#luminosity-noclip-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.763,187.344l9.07-5.343a8.2,8.2,0,0,0-4.854-1.429l-6.3,3.885A3.5,3.5,0,0,0,123.763,187.344Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-16)"
    }
  }))), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 108.278,
    y1: 195.204,
    x2: 127.925,
    y2: 182.805,
    xlinkHref: "#linear-gradient-62"
  })), _filter50 || (_filter50 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-71",
    x: 125.947,
    y: 183.419,
    width: 8.302,
    height: 4.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-71",
    x: 125.947,
    y: 183.419,
    width: 8.302,
    height: 4.925,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-18)",
      filter: "url(#luminosity-noclip-71)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.962,188.344c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.03-.361,2.533,2.533,0,0,0-.234-1.039c-2.732,1.6-5.8,3.392-8.069,4.717A9.821,9.821,0,0,0,127.962,188.344Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-18)"
    }
  }))), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 119.133,
    y1: 196.06,
    x2: 129.815,
    y2: 186.713,
    xlinkHref: "#linear-gradient-62"
  })), _filter51 || (_filter51 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-72",
    x: 123.231,
    y: 181.752,
    width: 9.655,
    height: 5.411,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-72",
    x: 123.231,
    y: 181.752,
    width: 9.655,
    height: 5.411,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-19)",
      filter: "url(#luminosity-noclip-72)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.01,187.163l5.876-3.461a3.271,3.271,0,0,0-1.847-1.717,9.831,9.831,0,0,0-2.124-.233l-5.684,3.5A5.042,5.042,0,0,0,127.01,187.163Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-19)"
    }
  }))), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 113.803,
    y1: 193.475,
    x2: 130.952,
    y2: 182.653,
    xlinkHref: "#linear-gradient-62"
  })), _filter52 || (_filter52 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-73",
    x: 126.501,
    y: 181.36,
    width: 5.451,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-73",
    x: 126.501,
    y: 181.36,
    width: 5.451,
    height: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-13)",
      filter: "url(#luminosity-noclip-73)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.97,181.36a8.473,8.473,0,0,0-1.469.127v.853a8.461,8.461,0,0,1,1.469-.129,6.716,6.716,0,0,1,3.98,1.148h0v-.853A6.738,6.738,0,0,0,127.97,181.36Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-20)"
    }
  }))), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 123.386,
    y1: 186.109,
    x2: 131.362,
    y2: 181.076,
    xlinkHref: "#linear-gradient-62"
  })), _filter53 || (_filter53 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-74",
    x: 124.743,
    y: 182.502,
    width: 6.439,
    height: 3.64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-74",
    x: 124.743,
    y: 182.502,
    width: 6.439,
    height: 3.64,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-14)",
      filter: "url(#luminosity-noclip-74)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.342,185.374l-1.367-.763a4.011,4.011,0,0,1-1.472.24,2.662,2.662,0,0,1-1.191-.327.934.934,0,0,1-.567-.7.881.881,0,0,1,.462-.759l-.323-.181.464-.276.323.18a2.9,2.9,0,0,1,1.163-.285,2.942,2.942,0,0,1,1.164.207l-.7.543a1.52,1.52,0,0,0-.906-.063l1.275.712a4.62,4.62,0,0,1,1.6-.317,2.512,2.512,0,0,1,1.144.317,1.091,1.091,0,0,1,.644.765.981.981,0,0,1-.478.858l.61.34-.464.277-.594-.332a3.172,3.172,0,0,1-1.319.3,3.658,3.658,0,0,1-1.436-.292l.743-.549a2.285,2.285,0,0,0,.642.136A2.08,2.08,0,0,0,129.342,185.374Zm-3.424-1.911a.316.316,0,0,0-.079.3.452.452,0,0,0,.233.26,1.068,1.068,0,0,0,.424.118,1.739,1.739,0,0,0,.55-.051Zm3.933,1.66a.388.388,0,0,0,.164-.359.484.484,0,0,0-.275-.328,1.121,1.121,0,0,0-.5-.134,1.837,1.837,0,0,0-.658.111Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-21)"
    }
  }))), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 122.967,
    y1: 190.191,
    x2: 127.481,
    y2: 185.009,
    xlinkHref: "#linear-gradient-62"
  })), _filter54 || (_filter54 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-75",
    x: 122.725,
    y: 183.632,
    width: 5.5,
    height: 3.886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-75",
    x: 122.725,
    y: 183.632,
    width: 5.5,
    height: 3.886,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-22)",
      filter: "url(#luminosity-noclip-75)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.725,183.632v2.185a8.068,8.068,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-22)"
    }
  }))), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 110.133,
    y1: 184.636,
    x2: 131.204,
    y2: 185.945,
    xlinkHref: "#linear-gradient-62"
  })), _filter55 || (_filter55 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-76",
    x: 121.636,
    y: 178.436,
    width: 11.158,
    height: 6.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-76",
    x: 121.636,
    y: 178.436,
    width: 11.158,
    height: 6.772,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-23)",
      filter: "url(#luminosity-noclip-76)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.724,185.208l9.07-5.343a8.2,8.2,0,0,0-4.854-1.429l-6.3,3.886A3.5,3.5,0,0,0,123.724,185.208Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-23)"
    }
  }))), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 108.239,
    y1: 193.068,
    x2: 127.887,
    y2: 180.67,
    xlinkHref: "#linear-gradient-62"
  })), _filter56 || (_filter56 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-77",
    x: 125.909,
    y: 181.283,
    width: 8.302,
    height: 4.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-77",
    x: 125.909,
    y: 181.283,
    width: 8.302,
    height: 4.925,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-24)",
      filter: "url(#luminosity-noclip-77)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.924,186.208c.1,0,.189-.006.285-.009l5.973-3.516a2.547,2.547,0,0,0,.029-.361,2.52,2.52,0,0,0-.234-1.039c-2.732,1.6-5.8,3.393-8.068,4.718A9.877,9.877,0,0,0,127.924,186.208Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-24)"
    }
  }))), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 119.095,
    y1: 193.924,
    x2: 129.777,
    y2: 184.577,
    xlinkHref: "#linear-gradient-62"
  })), _filter57 || (_filter57 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-78",
    x: 123.192,
    y: 179.617,
    width: 9.656,
    height: 5.411,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-78",
    x: 123.192,
    y: 179.617,
    width: 9.656,
    height: 5.411,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-25)",
      filter: "url(#luminosity-noclip-78)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.972,185.028l5.876-3.462A3.276,3.276,0,0,0,131,179.849a9.761,9.761,0,0,0-2.123-.232l-5.685,3.5A5.047,5.047,0,0,0,126.972,185.028Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-25)"
    }
  }))), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 113.765,
    y1: 191.339,
    x2: 130.913,
    y2: 180.517,
    xlinkHref: "#linear-gradient-62"
  })), _filter58 || (_filter58 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-79",
    x: 126.463,
    y: 179.224,
    width: 5.451,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-79",
    x: 126.463,
    y: 179.224,
    width: 5.451,
    height: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-26)",
      filter: "url(#luminosity-noclip-79)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.931,179.224a8.363,8.363,0,0,0-1.468.128v.853a8.36,8.36,0,0,1,1.468-.13,6.716,6.716,0,0,1,3.98,1.149h0v-.852A6.731,6.731,0,0,0,127.931,179.224Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-26)"
    }
  }))), _linearGradient76 || (_linearGradient76 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 123.348,
    y1: 183.974,
    x2: 131.324,
    y2: 178.94,
    xlinkHref: "#linear-gradient-62"
  })), _filter59 || (_filter59 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-80",
    x: 124.704,
    y: 180.367,
    width: 6.439,
    height: 3.64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-80",
    x: 124.704,
    y: 180.367,
    width: 6.439,
    height: 3.64,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-27)",
      filter: "url(#luminosity-noclip-80)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.3,183.239l-1.366-.763a4.059,4.059,0,0,1-1.472.24,2.683,2.683,0,0,1-1.192-.327.937.937,0,0,1-.567-.7.882.882,0,0,1,.462-.76l-.323-.18.464-.277.323.18a2.9,2.9,0,0,1,1.163-.285,2.95,2.95,0,0,1,1.165.207l-.7.543a1.509,1.509,0,0,0-.905-.062l1.275.712a4.6,4.6,0,0,1,1.6-.318,2.494,2.494,0,0,1,1.144.318,1.085,1.085,0,0,1,.644.764.978.978,0,0,1-.478.858l.61.34-.464.277-.593-.331a3.179,3.179,0,0,1-1.32.3,3.661,3.661,0,0,1-1.436-.292l.744-.549a2.287,2.287,0,0,0,.642.137A2.147,2.147,0,0,0,129.3,183.239Zm-3.424-1.912a.318.318,0,0,0-.079.3.451.451,0,0,0,.234.26,1.042,1.042,0,0,0,.423.118,1.678,1.678,0,0,0,.55-.051Zm3.934,1.661a.389.389,0,0,0,.163-.36.478.478,0,0,0-.275-.327,1.131,1.131,0,0,0-.5-.135,1.829,1.829,0,0,0-.657.111Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-27)"
    }
  }))), _linearGradient77 || (_linearGradient77 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 122.928,
    y1: 188.055,
    x2: 127.443,
    y2: 182.873,
    xlinkHref: "#linear-gradient-62"
  })), _filter60 || (_filter60 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-81",
    x: 122.738,
    y: 181.554,
    width: 5.5,
    height: 3.886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-81",
    x: 122.738,
    y: 181.554,
    width: 5.5,
    height: 3.886,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-29)",
      filter: "url(#luminosity-noclip-81)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.738,181.554v2.185a8.068,8.068,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-29)"
    }
  }))), _linearGradient78 || (_linearGradient78 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 110.147,
    y1: 182.558,
    x2: 131.217,
    y2: 183.867,
    xlinkHref: "#linear-gradient-62"
  })), _filter61 || (_filter61 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-82",
    x: 121.649,
    y: 176.358,
    width: 11.158,
    height: 6.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-82",
    x: 121.649,
    y: 176.358,
    width: 11.158,
    height: 6.772,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-30)",
      filter: "url(#luminosity-noclip-82)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.738,183.13l9.069-5.343a8.2,8.2,0,0,0-4.853-1.429l-6.3,3.885A3.5,3.5,0,0,0,123.738,183.13Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-30)"
    }
  }))), _linearGradient79 || (_linearGradient79 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 108.252,
    y1: 190.99,
    x2: 127.9,
    y2: 178.591,
    xlinkHref: "#linear-gradient-62"
  })), _filter62 || (_filter62 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-83",
    x: 125.922,
    y: 179.205,
    width: 8.302,
    height: 4.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-83",
    x: 125.922,
    y: 179.205,
    width: 8.302,
    height: 4.925,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-31)",
      filter: "url(#luminosity-noclip-83)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.937,184.13c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.029-.361,2.517,2.517,0,0,0-.234-1.039c-2.732,1.6-5.8,3.392-8.068,4.717A9.806,9.806,0,0,0,127.937,184.13Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-31)"
    }
  }))), _linearGradient80 || (_linearGradient80 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 119.108,
    y1: 191.846,
    x2: 129.79,
    y2: 182.499,
    xlinkHref: "#linear-gradient-62"
  })), _filter63 || (_filter63 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-84",
    x: 123.205,
    y: 177.538,
    width: 9.656,
    height: 5.411,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-84",
    x: 123.205,
    y: 177.538,
    width: 9.656,
    height: 5.411,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-32)",
      filter: "url(#luminosity-noclip-84)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.985,182.949l5.876-3.461a3.277,3.277,0,0,0-1.847-1.717,9.838,9.838,0,0,0-2.124-.233l-5.685,3.5A5.046,5.046,0,0,0,126.985,182.949Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-32)"
    }
  }))), _linearGradient81 || (_linearGradient81 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 113.778,
    y1: 189.261,
    x2: 130.926,
    y2: 178.439,
    xlinkHref: "#linear-gradient-62"
  })), _filter64 || (_filter64 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-85",
    x: 126.476,
    y: 177.146,
    width: 5.451,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-85",
    x: 126.476,
    y: 177.146,
    width: 5.451,
    height: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-33)",
      filter: "url(#luminosity-noclip-85)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.945,177.146a8.473,8.473,0,0,0-1.469.127v.854a8.363,8.363,0,0,1,1.469-.13,6.715,6.715,0,0,1,3.979,1.148h0v-.853A6.737,6.737,0,0,0,127.945,177.146Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-33)"
    }
  }))), _linearGradient82 || (_linearGradient82 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 123.361,
    y1: 181.895,
    x2: 131.337,
    y2: 176.862,
    xlinkHref: "#linear-gradient-62"
  })), _filter65 || (_filter65 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-86",
    x: 124.717,
    y: 178.288,
    width: 6.439,
    height: 3.64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-86",
    x: 124.717,
    y: 178.288,
    width: 6.439,
    height: 3.64,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-34)",
      filter: "url(#luminosity-noclip-86)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.316,181.16l-1.366-.763a4.037,4.037,0,0,1-1.472.241,2.676,2.676,0,0,1-1.191-.328.936.936,0,0,1-.568-.7.885.885,0,0,1,.462-.759l-.322-.181.463-.276.323.18a2.9,2.9,0,0,1,1.163-.285,2.95,2.95,0,0,1,1.165.207l-.7.543a1.517,1.517,0,0,0-.905-.063l1.275.712a4.62,4.62,0,0,1,1.595-.317,2.506,2.506,0,0,1,1.144.317,1.09,1.09,0,0,1,.645.765.983.983,0,0,1-.478.858l.609.34-.464.277-.593-.332a3.177,3.177,0,0,1-1.32.3,3.653,3.653,0,0,1-1.435-.292l.743-.549a2.287,2.287,0,0,0,.642.137A2.106,2.106,0,0,0,129.316,181.16Zm-3.424-1.911a.321.321,0,0,0-.079.3.454.454,0,0,0,.234.26,1.063,1.063,0,0,0,.424.118,1.739,1.739,0,0,0,.55-.051Zm3.934,1.66a.387.387,0,0,0,.163-.359.482.482,0,0,0-.275-.328,1.114,1.114,0,0,0-.5-.134,1.832,1.832,0,0,0-.657.111Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-34)"
    }
  }))), _linearGradient83 || (_linearGradient83 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 122.942,
    y1: 185.977,
    x2: 127.456,
    y2: 180.795,
    xlinkHref: "#linear-gradient-62"
  })), _filter66 || (_filter66 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-87",
    x: 122.77,
    y: 179.462,
    width: 5.5,
    height: 3.886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-87",
    x: 122.77,
    y: 179.462,
    width: 5.5,
    height: 3.886,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-35)",
      filter: "url(#luminosity-noclip-87)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.77,179.462v2.185a8.068,8.068,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-35)"
    }
  }))), _linearGradient84 || (_linearGradient84 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 110.178,
    y1: 180.466,
    x2: 131.249,
    y2: 181.774,
    xlinkHref: "#linear-gradient-62"
  })), _filter67 || (_filter67 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-88",
    x: 121.681,
    y: 174.266,
    width: 11.158,
    height: 6.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-88",
    x: 121.681,
    y: 174.266,
    width: 11.158,
    height: 6.772,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-36)",
      filter: "url(#luminosity-noclip-88)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.77,181.038l9.069-5.343a8.2,8.2,0,0,0-4.853-1.429l-6.305,3.885A3.5,3.5,0,0,0,123.77,181.038Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-36)"
    }
  }))), _linearGradient85 || (_linearGradient85 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 108.284,
    y1: 188.898,
    x2: 127.932,
    y2: 176.499,
    xlinkHref: "#linear-gradient-62"
  })), _filter68 || (_filter68 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-89",
    x: 125.954,
    y: 177.113,
    width: 8.302,
    height: 4.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-89",
    x: 125.954,
    y: 177.113,
    width: 8.302,
    height: 4.925,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-37)",
      filter: "url(#luminosity-noclip-89)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.969,182.038c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.029-.361,2.517,2.517,0,0,0-.234-1.039c-2.732,1.6-5.8,3.392-8.068,4.717A9.806,9.806,0,0,0,127.969,182.038Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-37)"
    }
  }))), _linearGradient86 || (_linearGradient86 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 119.14,
    y1: 189.753,
    x2: 129.822,
    y2: 180.407,
    xlinkHref: "#linear-gradient-62"
  })), _filter69 || (_filter69 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-90",
    x: 123.237,
    y: 175.446,
    width: 9.655,
    height: 5.411,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-90",
    x: 123.237,
    y: 175.446,
    width: 9.655,
    height: 5.411,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-38)",
      filter: "url(#luminosity-noclip-90)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.017,180.857l5.876-3.462a3.28,3.28,0,0,0-1.847-1.717,9.839,9.839,0,0,0-2.124-.232l-5.685,3.5A5.046,5.046,0,0,0,127.017,180.857Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-38)"
    }
  }))), _linearGradient87 || (_linearGradient87 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 113.81,
    y1: 187.169,
    x2: 130.958,
    y2: 176.347,
    xlinkHref: "#linear-gradient-62"
  })), _filter70 || (_filter70 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-91",
    x: 126.508,
    y: 175.053,
    width: 5.451,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-91",
    x: 126.508,
    y: 175.053,
    width: 5.451,
    height: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-40)",
      filter: "url(#luminosity-noclip-91)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.977,175.053a8.472,8.472,0,0,0-1.469.128v.853a8.365,8.365,0,0,1,1.469-.129,6.715,6.715,0,0,1,3.979,1.148h0V176.2A6.737,6.737,0,0,0,127.977,175.053Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-40)"
    }
  }))), _linearGradient88 || (_linearGradient88 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 123.393,
    y1: 179.803,
    x2: 131.369,
    y2: 174.77,
    xlinkHref: "#linear-gradient-62"
  })), _filter71 || (_filter71 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-92",
    x: 124.749,
    y: 176.196,
    width: 6.439,
    height: 3.64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-92",
    x: 124.749,
    y: 176.196,
    width: 6.439,
    height: 3.64,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-41)",
      filter: "url(#luminosity-noclip-92)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.348,179.068l-1.366-.763a4.017,4.017,0,0,1-1.472.24,2.662,2.662,0,0,1-1.191-.327.936.936,0,0,1-.568-.7.888.888,0,0,1,.462-.76l-.322-.18.463-.276.323.18a2.884,2.884,0,0,1,1.163-.285,2.95,2.95,0,0,1,1.165.207l-.7.542a1.524,1.524,0,0,0-.905-.062l1.275.712a4.62,4.62,0,0,1,1.595-.317,2.506,2.506,0,0,1,1.144.317,1.09,1.09,0,0,1,.645.765.981.981,0,0,1-.479.857l.61.341-.464.277-.593-.332a3.177,3.177,0,0,1-1.32.3,3.653,3.653,0,0,1-1.435-.292l.743-.549a2.285,2.285,0,0,0,.642.136A2.108,2.108,0,0,0,129.348,179.068Zm-3.424-1.912a.323.323,0,0,0-.079.3.452.452,0,0,0,.234.259,1.047,1.047,0,0,0,.424.119,1.713,1.713,0,0,0,.55-.052Zm3.934,1.661a.387.387,0,0,0,.163-.359.48.48,0,0,0-.275-.328,1.127,1.127,0,0,0-.5-.135,1.858,1.858,0,0,0-.657.112Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-41)"
    }
  }))), _linearGradient89 || (_linearGradient89 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 122.974,
    y1: 183.885,
    x2: 127.488,
    y2: 178.702,
    xlinkHref: "#linear-gradient-62"
  })), _filter72 || (_filter72 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-93",
    x: 114.182,
    y: 196.359,
    width: 5.5,
    height: 3.886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-93",
    x: 114.182,
    y: 196.359,
    width: 5.5,
    height: 3.886,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-42)",
      filter: "url(#luminosity-noclip-93)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.182,196.359v2.185a8.072,8.072,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-42)"
    }
  }))), _linearGradient90 || (_linearGradient90 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 101.591,
    y1: 197.363,
    x2: 122.662,
    y2: 198.671,
    xlinkHref: "#linear-gradient-62"
  })), _filter73 || (_filter73 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-94",
    x: 113.093,
    y: 191.163,
    width: 11.158,
    height: 6.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-94",
    x: 113.093,
    y: 191.163,
    width: 11.158,
    height: 6.772,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-43)",
      filter: "url(#luminosity-noclip-94)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.182,197.935l9.07-5.343a8.206,8.206,0,0,0-4.854-1.429l-6.3,3.885A3.5,3.5,0,0,0,115.182,197.935Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-43)"
    }
  }))), _linearGradient91 || (_linearGradient91 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 99.697,
    y1: 205.795,
    x2: 119.344,
    y2: 193.396,
    xlinkHref: "#linear-gradient-62"
  })), _filter74 || (_filter74 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-95",
    x: 117.366,
    y: 194.01,
    width: 8.302,
    height: 4.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-95",
    x: 117.366,
    y: 194.01,
    width: 8.302,
    height: 4.925,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-44)",
      filter: "url(#luminosity-noclip-95)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.381,198.935c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.03-.361,2.518,2.518,0,0,0-.235-1.039c-2.731,1.6-5.8,3.392-8.068,4.717A9.806,9.806,0,0,0,119.381,198.935Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-44)"
    }
  }))), _linearGradient92 || (_linearGradient92 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 110.552,
    y1: 206.65,
    x2: 121.234,
    y2: 197.304,
    xlinkHref: "#linear-gradient-62"
  })), _filter75 || (_filter75 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-96",
    x: 114.65,
    y: 192.343,
    width: 9.656,
    height: 5.411,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-96",
    x: 114.65,
    y: 192.343,
    width: 9.656,
    height: 5.411,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-45)",
      filter: "url(#luminosity-noclip-96)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.429,197.754l5.876-3.462a3.28,3.28,0,0,0-1.847-1.717,9.832,9.832,0,0,0-2.124-.232l-5.684,3.5A5.042,5.042,0,0,0,118.429,197.754Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-45)"
    }
  }))), _linearGradient93 || (_linearGradient93 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 105.222,
    y1: 204.066,
    x2: 122.371,
    y2: 193.244,
    xlinkHref: "#linear-gradient-62"
  })), _filter76 || (_filter76 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-97",
    x: 117.92,
    y: 191.95,
    width: 5.451,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-97",
    x: 117.92,
    y: 191.95,
    width: 5.451,
    height: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-46)",
      filter: "url(#luminosity-noclip-97)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.389,191.95a8.472,8.472,0,0,0-1.469.128v.853a8.365,8.365,0,0,1,1.469-.129,6.716,6.716,0,0,1,3.98,1.148h0V193.1A6.734,6.734,0,0,0,119.389,191.95Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-46)"
    }
  }))), _linearGradient94 || (_linearGradient94 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 114.805,
    y1: 196.7,
    x2: 122.781,
    y2: 191.667,
    xlinkHref: "#linear-gradient-62"
  })), _filter77 || (_filter77 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-98",
    x: 115.688,
    y: 192.529,
    width: 7.579,
    height: 4.401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-98",
    x: 115.688,
    y: 192.529,
    width: 7.579,
    height: 4.401,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-47)",
      filter: "url(#luminosity-noclip-98)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.727,196.33l-.645-.376c-.1.059-.212.125-.338.2l-.169.1.642.375-.54.308-.642-.374-.5.285-4.706-2.744.5-.285-.642-.374.539-.309.642.375.38-.217c.045-.026.09-.05.134-.073l-.645-.376.539-.309.7.408a1.816,1.816,0,0,1,.51-.08,2.7,2.7,0,0,1,.666.073,2.323,2.323,0,0,1,.66.259,1.289,1.289,0,0,1,.472.43.477.477,0,0,1,.05.45,2.28,2.28,0,0,1,.925-.036,2.546,2.546,0,0,1,.884.314,1.8,1.8,0,0,1,.512.428.683.683,0,0,1,.177.46.551.551,0,0,1-.24.393l.674.393Zm-5.4-2.186,1.088.635.469-.268q.418-.24.5-.307a.253.253,0,0,0,.121-.264.5.5,0,0,0-.262-.274,1.15,1.15,0,0,0-.446-.155.849.849,0,0,0-.435.058c-.081.034-.291.148-.628.34Zm1.871,1.091,1.258.734.663-.379a3.036,3.036,0,0,0,.463-.3.233.233,0,0,0,.072-.259.624.624,0,0,0-.3-.29,1.35,1.35,0,0,0-.437-.165,1.137,1.137,0,0,0-.439,0,2.928,2.928,0,0,0-.7.324Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-47)"
    }
  }))), _linearGradient95 || (_linearGradient95 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 112.407,
    y1: 204.343,
    x2: 118.88,
    y2: 195.541,
    xlinkHref: "#linear-gradient-62"
  })), _filter78 || (_filter78 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-99",
    x: 114.182,
    y: 194.159,
    width: 5.5,
    height: 3.886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-99",
    x: 114.182,
    y: 194.159,
    width: 5.5,
    height: 3.886,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-42)",
      filter: "url(#luminosity-noclip-99)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.182,194.159v2.185a8.072,8.072,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-48)"
    }
  }))), _linearGradient96 || (_linearGradient96 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 101.591,
    y1: 195.163,
    x2: 122.662,
    y2: 196.472,
    xlinkHref: "#linear-gradient-62"
  })), _filter79 || (_filter79 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-100",
    x: 113.093,
    y: 188.963,
    width: 11.158,
    height: 6.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-100",
    x: 113.093,
    y: 188.963,
    width: 11.158,
    height: 6.772,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-43)",
      filter: "url(#luminosity-noclip-100)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.182,195.735l9.07-5.343a8.206,8.206,0,0,0-4.854-1.429l-6.3,3.886A3.5,3.5,0,0,0,115.182,195.735Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-49)"
    }
  }))), _linearGradient97 || (_linearGradient97 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 99.697,
    y1: 203.595,
    x2: 119.344,
    y2: 191.197,
    xlinkHref: "#linear-gradient-62"
  })), _filter80 || (_filter80 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-101",
    x: 117.366,
    y: 191.81,
    width: 8.302,
    height: 4.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-101",
    x: 117.366,
    y: 191.81,
    width: 8.302,
    height: 4.925,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-44)",
      filter: "url(#luminosity-noclip-101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.381,196.735c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.03-.361,2.521,2.521,0,0,0-.235-1.039c-2.731,1.6-5.8,3.393-8.068,4.718A9.877,9.877,0,0,0,119.381,196.735Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-51)"
    }
  }))), _linearGradient98 || (_linearGradient98 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 110.552,
    y1: 204.451,
    x2: 121.234,
    y2: 195.104,
    xlinkHref: "#linear-gradient-62"
  })), _filter81 || (_filter81 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-102",
    x: 114.65,
    y: 190.144,
    width: 9.656,
    height: 5.411,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-102",
    x: 114.65,
    y: 190.144,
    width: 9.656,
    height: 5.411,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-45)",
      filter: "url(#luminosity-noclip-102)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.429,195.555l5.876-3.462a3.277,3.277,0,0,0-1.847-1.717,9.77,9.77,0,0,0-2.124-.232l-5.684,3.5A5.043,5.043,0,0,0,118.429,195.555Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-52)"
    }
  }))), _linearGradient99 || (_linearGradient99 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 105.222,
    y1: 201.866,
    x2: 122.371,
    y2: 191.044,
    xlinkHref: "#linear-gradient-62"
  })), _filter82 || (_filter82 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-103",
    x: 117.92,
    y: 189.751,
    width: 5.451,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-103",
    x: 117.92,
    y: 189.751,
    width: 5.451,
    height: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-46)",
      filter: "url(#luminosity-noclip-103)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.389,189.751a8.375,8.375,0,0,0-1.469.128v.853a8.363,8.363,0,0,1,1.469-.13,6.716,6.716,0,0,1,3.98,1.149h0V190.9A6.727,6.727,0,0,0,119.389,189.751Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-53)"
    }
  }))), _linearGradient100 || (_linearGradient100 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 114.805,
    y1: 194.501,
    x2: 122.781,
    y2: 189.467,
    xlinkHref: "#linear-gradient-62"
  })), _filter83 || (_filter83 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-104",
    x: 115.688,
    y: 190.33,
    width: 7.579,
    height: 4.401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-104",
    x: 115.688,
    y: 190.33,
    width: 7.579,
    height: 4.401,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-47)",
      filter: "url(#luminosity-noclip-104)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.727,194.13l-.645-.376c-.1.06-.212.125-.338.2l-.169.1.642.374-.54.309-.642-.375-.5.285-4.706-2.743.5-.285-.642-.375.539-.308.642.374.38-.217c.045-.026.09-.05.134-.073l-.645-.376.539-.308.7.408a1.781,1.781,0,0,1,.51-.08,2.651,2.651,0,0,1,.666.073,2.35,2.35,0,0,1,.66.258,1.29,1.29,0,0,1,.472.431.474.474,0,0,1,.05.449,2.316,2.316,0,0,1,.925-.036,2.546,2.546,0,0,1,.884.314,1.807,1.807,0,0,1,.512.429.683.683,0,0,1,.177.46.555.555,0,0,1-.24.393l.674.393Zm-5.4-2.185,1.088.634.469-.268q.418-.24.5-.307a.252.252,0,0,0,.121-.263.5.5,0,0,0-.262-.275,1.167,1.167,0,0,0-.446-.155.86.86,0,0,0-.435.058c-.081.035-.291.148-.628.341Zm1.871,1.091,1.258.734.663-.379a3.008,3.008,0,0,0,.463-.3.232.232,0,0,0,.072-.258.63.63,0,0,0-.3-.291,1.373,1.373,0,0,0-.437-.165,1.117,1.117,0,0,0-.439,0,2.873,2.873,0,0,0-.7.323Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-54)"
    }
  }))), _linearGradient101 || (_linearGradient101 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 112.407,
    y1: 202.143,
    x2: 118.88,
    y2: 193.342,
    xlinkHref: "#linear-gradient-62"
  })), _filter84 || (_filter84 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-105",
    x: 114.182,
    y: 191.96,
    width: 5.5,
    height: 3.886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-105",
    x: 114.182,
    y: 191.96,
    width: 5.5,
    height: 3.886,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-42)",
      filter: "url(#luminosity-noclip-105)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.182,191.96v2.185a8.072,8.072,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-55)"
    }
  }))), _linearGradient102 || (_linearGradient102 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 101.591,
    y1: 192.964,
    x2: 122.662,
    y2: 194.272,
    xlinkHref: "#linear-gradient-62"
  })), _filter85 || (_filter85 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-106",
    x: 113.093,
    y: 186.763,
    width: 11.158,
    height: 6.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-106",
    x: 113.093,
    y: 186.763,
    width: 11.158,
    height: 6.772,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-43)",
      filter: "url(#luminosity-noclip-106)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.182,193.536l9.07-5.343a8.213,8.213,0,0,0-4.854-1.43l-6.3,3.886A3.5,3.5,0,0,0,115.182,193.536Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-56)"
    }
  }))), _linearGradient103 || (_linearGradient103 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 99.697,
    y1: 201.396,
    x2: 119.344,
    y2: 188.997,
    xlinkHref: "#linear-gradient-62"
  })), _filter86 || (_filter86 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-107",
    x: 117.366,
    y: 189.611,
    width: 8.302,
    height: 4.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-107",
    x: 117.366,
    y: 189.611,
    width: 8.302,
    height: 4.925,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-44)",
      filter: "url(#luminosity-noclip-107)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.381,194.536c.1,0,.19-.007.285-.009l5.973-3.516a2.408,2.408,0,0,0,.03-.361,2.518,2.518,0,0,0-.235-1.039c-2.731,1.6-5.8,3.392-8.068,4.717A9.806,9.806,0,0,0,119.381,194.536Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-57)"
    }
  }))), _linearGradient104 || (_linearGradient104 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 110.552,
    y1: 202.251,
    x2: 121.234,
    y2: 192.905,
    xlinkHref: "#linear-gradient-62"
  })), _filter87 || (_filter87 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-108",
    x: 114.65,
    y: 187.944,
    width: 9.656,
    height: 5.411,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-108",
    x: 114.65,
    y: 187.944,
    width: 9.656,
    height: 5.411,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-45)",
      filter: "url(#luminosity-noclip-108)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.429,193.355l5.876-3.462a3.28,3.28,0,0,0-1.847-1.717,9.832,9.832,0,0,0-2.124-.232l-5.684,3.5A5.042,5.042,0,0,0,118.429,193.355Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-58)"
    }
  }))), _linearGradient105 || (_linearGradient105 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 105.222,
    y1: 199.667,
    x2: 122.371,
    y2: 188.845,
    xlinkHref: "#linear-gradient-62"
  })), _filter88 || (_filter88 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-109",
    x: 117.92,
    y: 187.551,
    width: 5.451,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-109",
    x: 117.92,
    y: 187.551,
    width: 5.451,
    height: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-46)",
      filter: "url(#luminosity-noclip-109)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.389,187.551a8.375,8.375,0,0,0-1.469.128v.853a8.365,8.365,0,0,1,1.469-.129,6.716,6.716,0,0,1,3.98,1.148h0V188.7A6.734,6.734,0,0,0,119.389,187.551Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-59)"
    }
  }))), _linearGradient106 || (_linearGradient106 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 114.805,
    y1: 192.301,
    x2: 122.781,
    y2: 187.268,
    xlinkHref: "#linear-gradient-62"
  })), _filter89 || (_filter89 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-110",
    x: 115.688,
    y: 188.13,
    width: 7.579,
    height: 4.401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-110",
    x: 115.688,
    y: 188.13,
    width: 7.579,
    height: 4.401,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-47)",
      filter: "url(#luminosity-noclip-110)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.727,191.931l-.645-.376c-.1.059-.212.125-.338.2l-.169.1.642.375-.54.308-.642-.374-.5.285-4.706-2.744.5-.285-.642-.374.539-.309.642.375.38-.217c.045-.026.09-.051.134-.073l-.645-.376.539-.309.7.408a1.816,1.816,0,0,1,.51-.08,2.7,2.7,0,0,1,.666.073,2.323,2.323,0,0,1,.66.259,1.289,1.289,0,0,1,.472.43.477.477,0,0,1,.05.45,2.28,2.28,0,0,1,.925-.036,2.546,2.546,0,0,1,.884.314,1.8,1.8,0,0,1,.512.428.683.683,0,0,1,.177.46.551.551,0,0,1-.24.393l.674.393Zm-5.4-2.186,1.088.635.469-.269a5.872,5.872,0,0,0,.5-.306.253.253,0,0,0,.121-.264.5.5,0,0,0-.262-.274,1.15,1.15,0,0,0-.446-.155.849.849,0,0,0-.435.058c-.081.034-.291.148-.628.34Zm1.871,1.091,1.258.734.663-.379a3.036,3.036,0,0,0,.463-.3.233.233,0,0,0,.072-.259.624.624,0,0,0-.3-.29,1.35,1.35,0,0,0-.437-.165,1.137,1.137,0,0,0-.439,0,2.928,2.928,0,0,0-.7.324Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-60)"
    }
  }))), _linearGradient107 || (_linearGradient107 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 112.407,
    y1: 199.944,
    x2: 118.88,
    y2: 191.142,
    xlinkHref: "#linear-gradient-62"
  })), _filter90 || (_filter90 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-111",
    x: 126.084,
    y: 199.592,
    width: 5.5,
    height: 3.886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-111",
    x: 126.084,
    y: 199.592,
    width: 5.5,
    height: 3.886,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-3)",
      filter: "url(#luminosity-noclip-111)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.084,199.592v2.185a8.072,8.072,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-3)"
    }
  }))), _linearGradient108 || (_linearGradient108 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 113.493,
    y1: 200.596,
    x2: 134.563,
    y2: 201.905,
    xlinkHref: "#linear-gradient-62"
  })), _filter91 || (_filter91 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-112",
    x: 124.995,
    y: 194.396,
    width: 11.158,
    height: 6.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-112",
    x: 124.995,
    y: 194.396,
    width: 11.158,
    height: 6.772,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-4)",
      filter: "url(#luminosity-noclip-112)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.084,201.168l9.069-5.343A8.2,8.2,0,0,0,131.3,194.4L125,198.281A3.5,3.5,0,0,0,127.084,201.168Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-4)"
    }
  }))), _linearGradient109 || (_linearGradient109 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 111.598,
    y1: 209.028,
    x2: 131.246,
    y2: 196.629,
    xlinkHref: "#linear-gradient-62"
  })), _filter92 || (_filter92 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-113",
    x: 129.268,
    y: 197.243,
    width: 8.302,
    height: 4.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-113",
    x: 129.268,
    y: 197.243,
    width: 8.302,
    height: 4.925,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-5)",
      filter: "url(#luminosity-noclip-113)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.283,202.168c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.029-.361,2.517,2.517,0,0,0-.234-1.039c-2.731,1.6-5.8,3.392-8.068,4.717A9.806,9.806,0,0,0,131.283,202.168Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-5)"
    }
  }))), _linearGradient110 || (_linearGradient110 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 122.454,
    y1: 209.884,
    x2: 133.136,
    y2: 200.537,
    xlinkHref: "#linear-gradient-62"
  })), _filter93 || (_filter93 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-114",
    x: 126.552,
    y: 195.576,
    width: 9.656,
    height: 5.411,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-114",
    x: 126.552,
    y: 195.576,
    width: 9.656,
    height: 5.411,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-6)",
      filter: "url(#luminosity-noclip-114)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.331,200.987l5.876-3.461a3.277,3.277,0,0,0-1.847-1.717,9.838,9.838,0,0,0-2.124-.233l-5.684,3.5A5.042,5.042,0,0,0,130.331,200.987Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-6)"
    }
  }))), _linearGradient111 || (_linearGradient111 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 117.124,
    y1: 207.299,
    x2: 134.273,
    y2: 196.477,
    xlinkHref: "#linear-gradient-62"
  })), _filter94 || (_filter94 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-115",
    x: 129.822,
    y: 195.184,
    width: 5.451,
    height: 2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-115",
    x: 129.822,
    y: 195.184,
    width: 5.451,
    height: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-7)",
      filter: "url(#luminosity-noclip-115)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.291,195.184a8.473,8.473,0,0,0-1.469.127v.854a8.363,8.363,0,0,1,1.469-.13,6.713,6.713,0,0,1,3.979,1.148h0v-.853A6.734,6.734,0,0,0,131.291,195.184Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-7)"
    }
  }))), _linearGradient112 || (_linearGradient112 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 126.707,
    y1: 199.933,
    x2: 134.683,
    y2: 194.9,
    xlinkHref: "#linear-gradient-62"
  })), _filter95 || (_filter95 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-116",
    x: 127.892,
    y: 196.004,
    width: 7.37,
    height: 3.998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-116",
    x: 127.892,
    y: 196.004,
    width: 7.37,
    height: 3.998,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-8)",
      filter: "url(#luminosity-noclip-116)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.663,196l.95.655a1.847,1.847,0,0,0-1.06.323.575.575,0,0,0-.289.748,1.231,1.231,0,0,0,.433.48l1.588-1.083.534.365-1.553,1.059c.06.032.138.07.235.117s.195.092.3.138l1.47-1,.534.365-1.316.9a3.477,3.477,0,0,0,.9.175,1.987,1.987,0,0,0,1.228-.282q.554-.378.406-.833l1.237.6a1.414,1.414,0,0,1-.612.723,3.715,3.715,0,0,1-2.194.556,6.1,6.1,0,0,1-1.859-.326l-.427.292-.534-.365.283-.193c-.067-.03-.137-.062-.209-.1-.124-.06-.232-.114-.322-.162l-.378.258-.534-.364.343-.235a2.148,2.148,0,0,1-.864-.977q-.27-.765.619-1.371A2.985,2.985,0,0,1,129.663,196Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-8)"
    }
  }))), _linearGradient113 || (_linearGradient113 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 121.493,
    y1: 393.37,
    x2: 128.583,
    y2: 384.563,
    gradientTransform: "matrix(0.999, -0.043, 0.043, 0.999, -14.388, -179.229)",
    xlinkHref: "#linear-gradient-62"
  })), _linearGradient114 || (_linearGradient114 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 150.944,
    y1: 536.468,
    x2: 148.566,
    y2: 536.468,
    gradientTransform: "translate(-57.824 -427.564) rotate(-5.975)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a688ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0abff"
  }))), _filter96 || (_filter96 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-117",
    x: 126.306,
    y: 75.745,
    width: 43.664,
    height: 26.175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-117",
    x: 126.306,
    y: 75.745,
    width: 43.664,
    height: 26.175,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-9)",
      filter: "url(#luminosity-noclip-117)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.168,82.322c-.933-.765-.88,0-.617.912l-16.395-7.342a2.285,2.285,0,0,0-2.154.293L128.69,91.626c-.963-.325-1.821-.373-2.135.284A1.487,1.487,0,0,0,126.938,94a1.4,1.4,0,0,0,.384.239l.02.009,16.835,7.529a2.246,2.246,0,0,0,2.118-.29l22.9-16.607S170.956,83.789,169.168,82.322Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-9)"
    }
  }))), _linearGradient115 || (_linearGradient115 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 157.132,
    y1: 542.122,
    x2: 156.719,
    y2: 541.394,
    gradientTransform: "translate(-57.824 -427.564) rotate(-5.975)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3300bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0abff"
  }))), _filter97 || (_filter97 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-118",
    x: 126.313,
    y: 75.744,
    width: 43.664,
    height: 26.175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-118",
    x: 126.313,
    y: 75.744,
    width: 43.664,
    height: 26.175,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-10)",
      filter: "url(#luminosity-noclip-118)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.175,82.321c-.933-.765-.88,0-.617.912l-16.395-7.342a2.285,2.285,0,0,0-2.154.293L128.7,91.625c-.963-.325-1.821-.373-2.135.284a1.488,1.488,0,0,0,.383,2.09,1.383,1.383,0,0,0,.383.238l.021.009,16.835,7.53a2.252,2.252,0,0,0,2.118-.29l22.9-16.608S170.962,83.788,169.175,82.321Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-10)"
    }
  }))), _linearGradient116 || (_linearGradient116 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 197.044,
    y1: 511.057,
    x2: 155.09,
    y2: 472.586,
    gradientTransform: "matrix(0.996, -0.09, 0.09, 0.996, -47.293, -368.645)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c74ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6ff"
  }))), _linearGradient117 || (_linearGradient117 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 151.844,
    y1: 544.416,
    x2: 154.894,
    y2: 543.143,
    gradientTransform: "translate(-57.824 -427.564) rotate(-5.975)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3818d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13ffe2"
  }))), _linearGradient118 || (_linearGradient118 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 156.485,
    y1: 483.557,
    x2: 154.95,
    y2: 482.149,
    xlinkHref: "#linear-gradient-118"
  })), _linearGradient119 || (_linearGradient119 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 153.709,
    y1: 543.355,
    x2: 156.759,
    y2: 542.083,
    xlinkHref: "#linear-gradient-119"
  })), _linearGradient120 || (_linearGradient120 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 158.335,
    y1: 482.47,
    x2: 156.799,
    y2: 481.062,
    xlinkHref: "#linear-gradient-118"
  })), _linearGradient121 || (_linearGradient121 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 150.859,
    y1: 545.057,
    x2: 152.136,
    y2: 544.525,
    xlinkHref: "#linear-gradient-119"
  })), _linearGradient122 || (_linearGradient122 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 154.618,
    y1: 483.967,
    x2: 153.648,
    y2: 483.077,
    xlinkHref: "#linear-gradient-118"
  })), _linearGradient123 || (_linearGradient123 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy",
    "data-name": "New Gradient Swatch copy",
    x1: 132.664,
    y1: 88.757,
    x2: 168.523,
    y2: 88.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55c3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6ff"
  }))), _linearGradient124 || (_linearGradient124 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: -1878.114,
    y1: -1667.663,
    x2: -1878.114,
    y2: -1672.905,
    gradientTransform: "matrix(0.913, 0.407, -0.934, 0.678, 301.93, 1989.006)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e9cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient125 || (_linearGradient125 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: -1878.764,
    y1: -1668.227,
    x2: -1878.764,
    y2: -1673.468,
    xlinkHref: "#linear-gradient-125"
  })), _linearGradient126 || (_linearGradient126 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: -8514.12,
    y1: -343.313,
    x2: -8517.458,
    y2: -343.313,
    gradientTransform: "matrix(-0.935, -0.168, -0.141, 0.984, -7918.502, -1056.686)",
    xlinkHref: "#linear-gradient-116"
  })), _filter98 || (_filter98 = /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-119",
    x: 63.696,
    y: 14.419,
    width: 50.688,
    height: 32.876,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-119",
    x: 63.696,
    y: 14.419,
    width: 50.688,
    height: 32.876,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-11)",
      filter: "url(#luminosity-noclip-119)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.708,21.14c1.134-.872,1.032.073.674,1.176l19.61-7.773a2.6,2.6,0,0,1,2.509.533l24.153,20.782c1.145-.325,2.154-.316,2.487.521.6,1.519-.043,2.171-.561,2.552a1.542,1.542,0,0,1-.462.264l-.025.01-20.135,7.97a2.557,2.557,0,0,1-2.467-.526L64.539,24.3S62.535,22.81,64.708,21.14Z",
    style: {
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-11)"
    }
  }))), _linearGradient127 || (_linearGradient127 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: -8504.529,
    y1: -333.647,
    x2: -8505.219,
    y2: -334.865,
    gradientTransform: "matrix(-0.935, -0.168, -0.141, 0.984, -7918.502, -1056.686)",
    xlinkHref: "#linear-gradient-117"
  })), _linearGradient128 || (_linearGradient128 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: -8456.856,
    y1: -226.788,
    x2: -8521.561,
    y2: -286.123,
    gradientTransform: "matrix(-0.937, -0.153, -0.128, 0.987, -7931.514, -997.447)",
    xlinkHref: "#linear-gradient-118"
  })), _linearGradient129 || (_linearGradient129 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 65.951,
    y1: 29.286,
    x2: 112.566,
    y2: 29.286,
    xlinkHref: "#New_Gradient_Swatch_copy"
  })), _linearGradient130 || (_linearGradient130 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: -8529.392,
    y1: -351.048,
    x2: -8443.363,
    y2: -349.921,
    gradientTransform: "matrix(-0.935, -0.168, -0.141, 0.984, -7918.502, -1056.686)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f47ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13ffe2"
  }))), _linearGradient131 || (_linearGradient131 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: -8510.182,
    y1: -331.243,
    x2: -8507.053,
    y2: -332.548,
    gradientTransform: "matrix(-0.935, -0.168, -0.141, 0.984, -7918.502, -1056.686)",
    xlinkHref: "#linear-gradient-119"
  })), _linearGradient132 || (_linearGradient132 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: -8517.533,
    y1: -270.282,
    x2: -8519.108,
    y2: -271.726,
    gradientTransform: "matrix(-0.937, -0.153, -0.128, 0.987, -7931.514, -997.447)",
    xlinkHref: "#linear-gradient-118"
  })), _linearGradient133 || (_linearGradient133 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: -8508.269,
    y1: -332.33,
    x2: -8505.14,
    y2: -333.636,
    gradientTransform: "matrix(-0.935, -0.168, -0.141, 0.984, -7918.502, -1056.686)",
    xlinkHref: "#linear-gradient-119"
  })), _linearGradient134 || (_linearGradient134 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: -8515.636,
    y1: -271.397,
    x2: -8517.211,
    y2: -272.841,
    gradientTransform: "matrix(-0.937, -0.153, -0.128, 0.987, -7931.514, -997.447)",
    xlinkHref: "#linear-gradient-118"
  })), _linearGradient135 || (_linearGradient135 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: -8511.193,
    y1: -330.585,
    x2: -8509.883,
    y2: -331.131,
    gradientTransform: "matrix(-0.935, -0.168, -0.141, 0.984, -7918.502, -1056.686)",
    xlinkHref: "#linear-gradient-119"
  })), _linearGradient136 || (_linearGradient136 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: -8519.449,
    y1: -269.861,
    x2: -8520.444,
    y2: -270.774,
    gradientTransform: "matrix(-0.937, -0.153, -0.128, 0.987, -7931.514, -997.447)",
    xlinkHref: "#linear-gradient-118"
  })), _linearGradient137 || (_linearGradient137 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: -9067.518,
    y1: 1523.615,
    x2: -9066.997,
    y2: 1524.517,
    gradientTransform: "matrix(-0.909, 0.257, -0.264, 1.113, -7746.436, 682.797)",
    xlinkHref: "#linear-gradient-131"
  })), _linearGradient138 || (_linearGradient138 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: -7761.035,
    y1: 1906.194,
    x2: -7761.035,
    y2: 1896.195,
    gradientTransform: "matrix(-0.881, 0.347, 0.854, 0.736, -8361.589, 1329.976)",
    xlinkHref: "#linear-gradient-125"
  })), _linearGradient139 || (_linearGradient139 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: -7762.177,
    y1: 1905.205,
    x2: -7762.177,
    y2: 1895.206,
    gradientTransform: "matrix(-0.881, 0.347, 0.854, 0.736, -8361.589, 1329.976)",
    xlinkHref: "#linear-gradient-125"
  })), _linearGradient140 || (_linearGradient140 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: -1261.453,
    y1: -2868.405,
    x2: -1258.337,
    y2: -2868.405,
    gradientTransform: "matrix(0.721, 0.693, -0.693, 0.721, -985.325, 3016.297)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a477ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2aaff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Funnel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Working_Layer",
    "data-name": "Working Layer"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.7,164.338a5.664,5.664,0,0,0,.387-.807l2.2-4.6h-2.816a9.164,9.164,0,0,0-3.073-2.713c-5.353-3.09-14.032-3.09-19.386,0a9.194,9.194,0,0,0-3.073,2.713h-2.816l2.2,4.594a5.523,5.523,0,0,0,.391.816l0,.01h0a8.807,8.807,0,0,0,3.292,3.06c5.354,3.09,14.033,3.09,19.386,0a8.807,8.807,0,0,0,3.292-3.06h0Z",
    style: {
      fill: "#b45ef4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.165,102.759l-111.347-.081,39.78,57.206a10.379,10.379,0,0,0,3.794,3.485c6.248,3.608,16.378,3.608,22.626,0a10.383,10.383,0,0,0,3.795-3.485Z",
    style: {
      fill: "#721bd5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.254,76.7h0l-.012-.019q-.327-.5-.681-1l-4.184-6.167h-1.51a49.227,49.227,0,0,0-7.528-5.288c-23.648-13.653-61.989-13.653-85.636,0a49.189,49.189,0,0,0-7.529,5.288H74.211l-4.62,7.5h0c-7.755,12.362-3.054,26.741,14.111,36.652,23.648,13.653,61.989,13.653,85.636,0C186.65,103.673,191.287,89.133,183.254,76.7Z",
    style: {
      fill: "#983be9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.295,
    cy: 81.204,
    rx: 55.87,
    ry: 32.257,
    style: {
      fill: "#b45ef4"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.295,
    cy: 80.851,
    rx: 51.918,
    ry: 30.008,
    style: {
      fill: "#721bd5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.857,86.22c.013,8.956-5.894,17.914-17.73,24.747-23.648,13.653-61.988,13.653-85.636,0-10.636-6.141-16.481-14-17.549-22.026,0,8.949,5.905,17.9,17.731,24.726,23.648,13.653,61.988,13.653,85.636,0C182.335,106.147,188.182,96.053,186.857,86.22Z",
    style: {
      fill: "#b45ef4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_23",
    "data-name": 23
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-61)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-62)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "150.114 162.924 102.163 162.924 101.912 195.492 150.364 195.492 150.114 162.924",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-61)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_6",
    "data-name": 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.212,218.355l-19.6-11.406c-1.654-.955-1.447-2.623.463-3.726l18.685-10.886a7.173,7.173,0,0,1,6.454-.268l19.6,11.406c1.654.955,1.447,2.623-.464,3.726l-18.684,10.886A7.173,7.173,0,0,1,123.212,218.355Z",
    style: {
      fill: "#00233b",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.363,198.005V195.19l-3.264-.525-17.062-9.891c-2.547-1.476-7-1.3-9.946.4l-15.737,9.05c-.129.074-.252.15-.37.228l-2.071.359v2.711h0a2.974,2.974,0,0,0,1.715,2.442l18.612,10.789c2.546,1.476,7,1.3,9.945-.395l15.738-9.05c1.637-.941,2.464-2.153,2.438-3.3Z",
    style: {
      fill: "#721bd5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.241,207.983l-18.612-10.789c-2.547-1.476-2.223-4.046.724-5.741L120.09,182.4c2.947-1.695,7.4-1.871,9.946-.4L148.648,192.8c2.546,1.477,2.222,4.047-.724,5.741l-15.738,9.05C129.24,209.282,124.787,209.459,122.241,207.983Z",
    style: {
      fill: "#b45ef4"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.876,186.61c-.871-1.5-3.186-2.576-5.914-2.576s-5.043,1.075-5.914,2.576h-.374v1.31c0,2.146,2.815,3.886,6.288,3.886s6.288-1.74,6.288-3.886v-1.31Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-63)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.763,187.92v2.185a8.072,8.072,0,0,0,5.5,1.7V190.5Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-62)"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.962,
    cy: 186.61,
    rx: 6.288,
    ry: 3.886,
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-64)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.763,189.5l9.07-5.343a8.2,8.2,0,0,0-4.854-1.429l-6.3,3.886A3.5,3.5,0,0,0,123.763,189.5Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-63)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-65)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.962,190.5c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.03-.361,2.536,2.536,0,0,0-.234-1.039c-2.732,1.6-5.8,3.393-8.069,4.718A9.885,9.885,0,0,0,127.962,190.5Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-64)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.983,186.435c0,1.615-2.248,2.924-5.021,2.924s-5.021-1.309-5.021-2.924,2.248-2.923,5.021-2.923S132.983,184.821,132.983,186.435Z",
    style: {
      fill: "#f9b815"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-66)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.01,189.316l5.876-3.462a3.277,3.277,0,0,0-1.847-1.717,9.77,9.77,0,0,0-2.124-.232l-5.684,3.5A5.043,5.043,0,0,0,127.01,189.316Z",
    style: {
      opacity: 0.5,
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-65)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.962,183.512c-2.773,0-5.021,1.309-5.021,2.923a1.744,1.744,0,0,0,.059.426c.355-1.412,2.438-2.5,4.962-2.5s4.607,1.086,4.962,2.5a1.744,1.744,0,0,0,.059-.426C132.983,184.821,130.735,183.512,127.962,183.512Z",
    style: {
      fill: "#dd7105"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-67)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.97,183.512a8.375,8.375,0,0,0-1.469.128v.853a8.363,8.363,0,0,1,1.469-.13,6.709,6.709,0,0,1,3.98,1.149h0v-.852A6.731,6.731,0,0,0,127.97,183.512Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-66)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.741,188.039a.918.918,0,0,0,.3-.577l.011,0v-.56l-.383-.157a2.011,2.011,0,0,0-.266-.176,2.5,2.5,0,0,0-1.144-.318,4.62,4.62,0,0,0-1.6.317l-1.275-.712a1.52,1.52,0,0,1,.906.063l.7-.543v-.517l-.9.309,0,.007c-.09-.006-.18-.009-.27-.006a2.9,2.9,0,0,0-1.163.285l-.165-.092.062-.049v-.241l-.684-.038v.813l.221-.173.1.057a1.514,1.514,0,0,0-.256.234l-.208-.071,0,.6a.932.932,0,0,0,.567.7,2.688,2.688,0,0,0,1.191.327,4.053,4.053,0,0,0,1.472-.24l1.367.763a2.157,2.157,0,0,1-.588.034,2.268,2.268,0,0,1-.41-.07l.032-.113-1.007.078v.517a3.658,3.658,0,0,0,1.436.292,3.171,3.171,0,0,0,1.319-.3l.594.331.464-.277v-.517Zm-4.245-1.226a1.068,1.068,0,0,1-.424-.118.449.449,0,0,1-.233-.26.316.316,0,0,1,.079-.3l1.128.63A1.683,1.683,0,0,1,126.5,186.813Zm3.355.979-1.272-.71a1.837,1.837,0,0,1,.658-.111,1.109,1.109,0,0,1,.5.135.481.481,0,0,1,.275.327A.388.388,0,0,1,129.851,187.792Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.342,187.527l-1.367-.763a4.053,4.053,0,0,1-1.472.24,2.688,2.688,0,0,1-1.191-.327.932.932,0,0,1-.567-.7.882.882,0,0,1,.462-.76l-.323-.18.464-.277.323.18a2.9,2.9,0,0,1,1.163-.285,2.942,2.942,0,0,1,1.164.207l-.7.543a1.512,1.512,0,0,0-.906-.062l1.275.711a4.62,4.62,0,0,1,1.6-.317,2.5,2.5,0,0,1,1.144.318,1.088,1.088,0,0,1,.644.764.98.98,0,0,1-.478.858l.61.34-.464.277-.594-.331a3.171,3.171,0,0,1-1.319.3,3.658,3.658,0,0,1-1.436-.292l.743-.549a2.287,2.287,0,0,0,.642.137A2.157,2.157,0,0,0,129.342,187.527Zm-3.424-1.912a.316.316,0,0,0-.079.3.452.452,0,0,0,.233.26,1.052,1.052,0,0,0,.424.118,1.683,1.683,0,0,0,.55-.051Zm3.933,1.66a.388.388,0,0,0,.164-.359.481.481,0,0,0-.275-.327,1.109,1.109,0,0,0-.5-.135,1.837,1.837,0,0,0-.658.111Z",
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-68)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.342,187.527l-1.367-.763a4.053,4.053,0,0,1-1.472.24,2.688,2.688,0,0,1-1.191-.327.932.932,0,0,1-.567-.7.882.882,0,0,1,.462-.76l-.323-.18.464-.277.323.18a2.9,2.9,0,0,1,1.163-.285,2.942,2.942,0,0,1,1.164.207l-.7.543a1.512,1.512,0,0,0-.906-.062l1.275.711a4.62,4.62,0,0,1,1.6-.317,2.5,2.5,0,0,1,1.144.318,1.088,1.088,0,0,1,.644.764.98.98,0,0,1-.478.858l.61.34-.464.277-.594-.331a3.171,3.171,0,0,1-1.319.3,3.658,3.658,0,0,1-1.436-.292l.743-.549a2.287,2.287,0,0,0,.642.137A2.157,2.157,0,0,0,129.342,187.527Zm-3.424-1.912a.316.316,0,0,0-.079.3.452.452,0,0,0,.233.26,1.052,1.052,0,0,0,.424.118,1.683,1.683,0,0,0,.55-.051Zm3.933,1.66a.388.388,0,0,0,.164-.359.481.481,0,0,0-.275-.327,1.109,1.109,0,0,0-.5-.135,1.837,1.837,0,0,0-.658.111Z",
    style: {
      fill: "url(#linear-gradient-67)"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.876,184.458c-.871-1.5-3.186-2.576-5.914-2.576s-5.043,1.075-5.914,2.576h-.374v1.31c0,2.146,2.815,3.886,6.288,3.886s6.288-1.74,6.288-3.886v-1.31Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-69)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.763,185.768v2.185a8.072,8.072,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-68)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.25,184.458c0,2.146-2.815,3.886-6.288,3.886s-6.288-1.74-6.288-3.886,2.815-3.886,6.288-3.886S134.25,182.312,134.25,184.458Z",
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-70)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.763,187.344l9.07-5.343a8.2,8.2,0,0,0-4.854-1.429l-6.3,3.885A3.5,3.5,0,0,0,123.763,187.344Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-69)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-71)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.962,188.344c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.03-.361,2.533,2.533,0,0,0-.234-1.039c-2.732,1.6-5.8,3.392-8.069,4.717A9.821,9.821,0,0,0,127.962,188.344Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-70)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.983,184.283c0,1.615-2.248,2.924-5.021,2.924s-5.021-1.309-5.021-2.924,2.248-2.923,5.021-2.923S132.983,182.668,132.983,184.283Z",
    style: {
      fill: "#f9b815"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-72)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.01,187.163l5.876-3.461a3.271,3.271,0,0,0-1.847-1.717,9.831,9.831,0,0,0-2.124-.233l-5.684,3.5A5.042,5.042,0,0,0,127.01,187.163Z",
    style: {
      opacity: 0.5,
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-71)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.962,181.36c-2.773,0-5.021,1.308-5.021,2.923a1.744,1.744,0,0,0,.059.426c.355-1.412,2.438-2.5,4.962-2.5s4.607,1.086,4.962,2.5a1.744,1.744,0,0,0,.059-.426C132.983,182.668,130.735,181.36,127.962,181.36Z",
    style: {
      fill: "#dd7105"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-73)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.97,181.36a8.473,8.473,0,0,0-1.469.127v.853a8.461,8.461,0,0,1,1.469-.129,6.716,6.716,0,0,1,3.98,1.148h0v-.853A6.738,6.738,0,0,0,127.97,181.36Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-72)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.741,185.886a.92.92,0,0,0,.3-.576l.01,0v-.56l-.383-.158a2.045,2.045,0,0,0-.266-.176,2.512,2.512,0,0,0-1.144-.317,4.62,4.62,0,0,0-1.6.317l-1.275-.712a1.52,1.52,0,0,1,.906.063l.7-.543v-.517l-.9.308,0,.008c-.09-.006-.18-.009-.27-.006a2.9,2.9,0,0,0-1.163.285l-.165-.092.062-.049v-.241l-.684-.039v.813l.221-.172.1.057a1.511,1.511,0,0,0-.256.234l-.208-.071,0,.6a.934.934,0,0,0,.567.7,2.662,2.662,0,0,0,1.191.327,4.011,4.011,0,0,0,1.472-.24l1.367.763a2.118,2.118,0,0,1-.588.034,2.266,2.266,0,0,1-.41-.069l.032-.113-1.007.078v.517a3.658,3.658,0,0,0,1.436.292,3.172,3.172,0,0,0,1.319-.3l.594.332.464-.277v-.517Zm-4.245-1.225a1.052,1.052,0,0,1-.424-.119.45.45,0,0,1-.233-.259.318.318,0,0,1,.079-.3l1.128.63A1.713,1.713,0,0,1,126.5,184.661Zm3.355.979-1.272-.71a1.863,1.863,0,0,1,.658-.112,1.134,1.134,0,0,1,.5.135.482.482,0,0,1,.275.328A.388.388,0,0,1,129.851,185.64Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.342,185.374l-1.367-.763a4.011,4.011,0,0,1-1.472.24,2.662,2.662,0,0,1-1.191-.327.934.934,0,0,1-.567-.7.881.881,0,0,1,.462-.759l-.323-.181.464-.276.323.18a2.9,2.9,0,0,1,1.163-.285,2.942,2.942,0,0,1,1.164.207l-.7.543a1.52,1.52,0,0,0-.906-.063l1.275.712a4.62,4.62,0,0,1,1.6-.317,2.512,2.512,0,0,1,1.144.317,1.091,1.091,0,0,1,.644.765.981.981,0,0,1-.478.858l.61.34-.464.277-.594-.332a3.172,3.172,0,0,1-1.319.3,3.658,3.658,0,0,1-1.436-.292l.743-.549a2.285,2.285,0,0,0,.642.136A2.08,2.08,0,0,0,129.342,185.374Zm-3.424-1.911a.316.316,0,0,0-.079.3.452.452,0,0,0,.233.26,1.068,1.068,0,0,0,.424.118,1.739,1.739,0,0,0,.55-.051Zm3.933,1.66a.388.388,0,0,0,.164-.359.484.484,0,0,0-.275-.328,1.121,1.121,0,0,0-.5-.134,1.837,1.837,0,0,0-.658.111Z",
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-74)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.342,185.374l-1.367-.763a4.011,4.011,0,0,1-1.472.24,2.662,2.662,0,0,1-1.191-.327.934.934,0,0,1-.567-.7.881.881,0,0,1,.462-.759l-.323-.181.464-.276.323.18a2.9,2.9,0,0,1,1.163-.285,2.942,2.942,0,0,1,1.164.207l-.7.543a1.52,1.52,0,0,0-.906-.063l1.275.712a4.62,4.62,0,0,1,1.6-.317,2.512,2.512,0,0,1,1.144.317,1.091,1.091,0,0,1,.644.765.981.981,0,0,1-.478.858l.61.34-.464.277-.594-.332a3.172,3.172,0,0,1-1.319.3,3.658,3.658,0,0,1-1.436-.292l.743-.549a2.285,2.285,0,0,0,.642.136A2.08,2.08,0,0,0,129.342,185.374Zm-3.424-1.911a.316.316,0,0,0-.079.3.452.452,0,0,0,.233.26,1.068,1.068,0,0,0,.424.118,1.739,1.739,0,0,0,.55-.051Zm3.933,1.66a.388.388,0,0,0,.164-.359.484.484,0,0,0-.275-.328,1.121,1.121,0,0,0-.5-.134,1.837,1.837,0,0,0-.658.111Z",
    style: {
      fill: "url(#linear-gradient-73)"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.837,182.322c-.871-1.5-3.186-2.576-5.913-2.576s-5.043,1.075-5.914,2.576h-.374v1.31c0,2.146,2.815,3.886,6.288,3.886s6.287-1.74,6.287-3.886v-1.31Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-75)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.725,183.632v2.185a8.068,8.068,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-74)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.211,182.322c0,2.146-2.815,3.886-6.287,3.886s-6.288-1.74-6.288-3.886,2.815-3.886,6.288-3.886S134.211,180.176,134.211,182.322Z",
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-76)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.724,185.208l9.07-5.343a8.2,8.2,0,0,0-4.854-1.429l-6.3,3.886A3.5,3.5,0,0,0,123.724,185.208Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-75)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-77)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.924,186.208c.1,0,.189-.006.285-.009l5.973-3.516a2.547,2.547,0,0,0,.029-.361,2.52,2.52,0,0,0-.234-1.039c-2.732,1.6-5.8,3.393-8.068,4.718A9.877,9.877,0,0,0,127.924,186.208Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-76)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.945,182.147c0,1.615-2.248,2.924-5.021,2.924s-5.022-1.309-5.022-2.924,2.248-2.923,5.022-2.923S132.945,180.533,132.945,182.147Z",
    style: {
      fill: "#f9b815"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-78)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.972,185.028l5.876-3.462A3.276,3.276,0,0,0,131,179.849a9.761,9.761,0,0,0-2.123-.232l-5.685,3.5A5.047,5.047,0,0,0,126.972,185.028Z",
    style: {
      opacity: 0.5,
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-77)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.924,179.224c-2.774,0-5.022,1.309-5.022,2.924a1.742,1.742,0,0,0,.059.425c.355-1.412,2.438-2.5,4.963-2.5s4.607,1.086,4.962,2.5a1.742,1.742,0,0,0,.059-.425C132.945,180.533,130.7,179.224,127.924,179.224Z",
    style: {
      fill: "#dd7105"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-79)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.931,179.224a8.363,8.363,0,0,0-1.468.128v.853a8.36,8.36,0,0,1,1.468-.13,6.716,6.716,0,0,1,3.98,1.149h0v-.852A6.731,6.731,0,0,0,127.931,179.224Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-78)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.7,183.751a.925.925,0,0,0,.3-.577l.01,0v-.56l-.382-.157a2.025,2.025,0,0,0-.267-.176,2.494,2.494,0,0,0-1.144-.318,4.62,4.62,0,0,0-1.6.317l-1.275-.711a1.509,1.509,0,0,1,.905.062l.7-.543v-.517l-.9.309,0,.007a2.69,2.69,0,0,0-.27-.006,2.9,2.9,0,0,0-1.163.285l-.165-.092.063-.049v-.241l-.685-.038v.813l.222-.173.1.057a1.5,1.5,0,0,0-.255.234l-.209-.07,0,.6a.937.937,0,0,0,.567.7,2.7,2.7,0,0,0,1.192.327,4.059,4.059,0,0,0,1.472-.24l1.366.763a2.147,2.147,0,0,1-.587.034,2.278,2.278,0,0,1-.411-.07l.032-.113-1.007.078v.517a3.661,3.661,0,0,0,1.436.292,3.179,3.179,0,0,0,1.32-.3l.593.331.464-.277v-.517Zm-4.245-1.226a1.042,1.042,0,0,1-.423-.118.454.454,0,0,1-.234-.26.318.318,0,0,1,.079-.3l1.128.63A1.678,1.678,0,0,1,126.457,182.525Zm3.356.979-1.272-.71a1.829,1.829,0,0,1,.657-.111,1.105,1.105,0,0,1,.5.135.478.478,0,0,1,.275.327A.387.387,0,0,1,129.813,183.5Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3,183.239l-1.366-.763a4.059,4.059,0,0,1-1.472.24,2.683,2.683,0,0,1-1.192-.327.937.937,0,0,1-.567-.7.882.882,0,0,1,.462-.76l-.323-.18.464-.277.323.18a2.9,2.9,0,0,1,1.163-.285,2.95,2.95,0,0,1,1.165.207l-.7.543a1.509,1.509,0,0,0-.905-.062l1.275.712a4.6,4.6,0,0,1,1.6-.318,2.494,2.494,0,0,1,1.144.318,1.085,1.085,0,0,1,.644.764.978.978,0,0,1-.478.858l.61.34-.464.277-.593-.331a3.179,3.179,0,0,1-1.32.3,3.661,3.661,0,0,1-1.436-.292l.744-.549a2.287,2.287,0,0,0,.642.137A2.147,2.147,0,0,0,129.3,183.239Zm-3.424-1.912a.318.318,0,0,0-.079.3.451.451,0,0,0,.234.26,1.042,1.042,0,0,0,.423.118,1.678,1.678,0,0,0,.55-.051Zm3.934,1.661a.389.389,0,0,0,.163-.36.478.478,0,0,0-.275-.327,1.131,1.131,0,0,0-.5-.135,1.829,1.829,0,0,0-.657.111Z",
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-80)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.3,183.239l-1.366-.763a4.059,4.059,0,0,1-1.472.24,2.683,2.683,0,0,1-1.192-.327.937.937,0,0,1-.567-.7.882.882,0,0,1,.462-.76l-.323-.18.464-.277.323.18a2.9,2.9,0,0,1,1.163-.285,2.95,2.95,0,0,1,1.165.207l-.7.543a1.509,1.509,0,0,0-.905-.062l1.275.712a4.6,4.6,0,0,1,1.6-.318,2.494,2.494,0,0,1,1.144.318,1.085,1.085,0,0,1,.644.764.978.978,0,0,1-.478.858l.61.34-.464.277-.593-.331a3.179,3.179,0,0,1-1.32.3,3.661,3.661,0,0,1-1.436-.292l.744-.549a2.287,2.287,0,0,0,.642.137A2.147,2.147,0,0,0,129.3,183.239Zm-3.424-1.912a.318.318,0,0,0-.079.3.451.451,0,0,0,.234.26,1.042,1.042,0,0,0,.423.118,1.678,1.678,0,0,0,.55-.051Zm3.934,1.661a.389.389,0,0,0,.163-.36.478.478,0,0,0-.275-.327,1.131,1.131,0,0,0-.5-.135,1.829,1.829,0,0,0-.657.111Z",
    style: {
      fill: "url(#linear-gradient-79)"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.85,180.244c-.87-1.5-3.186-2.576-5.913-2.576s-5.043,1.075-5.914,2.576h-.374v1.31c0,2.146,2.815,3.886,6.288,3.886s6.287-1.74,6.287-3.886v-1.31Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-81)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.738,181.554v2.185a8.068,8.068,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-80)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.224,180.244c0,2.146-2.815,3.886-6.287,3.886s-6.288-1.74-6.288-3.886,2.815-3.886,6.288-3.886S134.224,178.1,134.224,180.244Z",
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-82)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.738,183.13l9.069-5.343a8.2,8.2,0,0,0-4.853-1.429l-6.3,3.885A3.5,3.5,0,0,0,123.738,183.13Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-81)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-83)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.937,184.13c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.029-.361,2.517,2.517,0,0,0-.234-1.039c-2.732,1.6-5.8,3.392-8.068,4.717A9.806,9.806,0,0,0,127.937,184.13Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-82)"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.937,
    cy: 180.069,
    rx: 5.021,
    ry: 2.924,
    style: {
      fill: "#f9b815"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-84)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.985,182.949l5.876-3.461a3.277,3.277,0,0,0-1.847-1.717,9.838,9.838,0,0,0-2.124-.233l-5.685,3.5A5.046,5.046,0,0,0,126.985,182.949Z",
    style: {
      opacity: 0.5,
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-83)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.937,177.146c-2.774,0-5.022,1.308-5.022,2.923a1.7,1.7,0,0,0,.06.426c.354-1.412,2.438-2.5,4.962-2.5s4.607,1.086,4.962,2.5a1.744,1.744,0,0,0,.059-.426C132.958,178.454,130.71,177.146,127.937,177.146Z",
    style: {
      fill: "#dd7105"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-85)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.945,177.146a8.473,8.473,0,0,0-1.469.127v.854a8.363,8.363,0,0,1,1.469-.13,6.715,6.715,0,0,1,3.979,1.148h0v-.853A6.737,6.737,0,0,0,127.945,177.146Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-84)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.715,181.672a.915.915,0,0,0,.3-.576l.01,0v-.56l-.382-.158a2.13,2.13,0,0,0-.267-.176,2.506,2.506,0,0,0-1.144-.317,4.62,4.62,0,0,0-1.595.317l-1.275-.712a1.517,1.517,0,0,1,.905.063l.7-.543V178.5l-.9.308,0,.008c-.09-.006-.18-.009-.271-.006a2.9,2.9,0,0,0-1.163.285L125.48,179l.063-.049v-.241l-.684-.039v.813l.221-.172.1.057a1.464,1.464,0,0,0-.255.234l-.209-.071,0,.6a.936.936,0,0,0,.568.7,2.662,2.662,0,0,0,1.191.327,4.014,4.014,0,0,0,1.472-.24l1.366.763a2.108,2.108,0,0,1-.587.034,2.277,2.277,0,0,1-.411-.069l.033-.113-1.007.078v.517a3.653,3.653,0,0,0,1.435.292,3.177,3.177,0,0,0,1.32-.3l.593.332.464-.277v-.517Zm-4.244-1.225a1.047,1.047,0,0,1-.424-.119.452.452,0,0,1-.234-.259.323.323,0,0,1,.079-.3l1.129.63A1.713,1.713,0,0,1,126.471,180.447Zm3.355.979-1.272-.71a1.832,1.832,0,0,1,.657-.111,1.114,1.114,0,0,1,.5.134.48.48,0,0,1,.275.328A.387.387,0,0,1,129.826,181.426Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.316,181.16l-1.366-.763a4.037,4.037,0,0,1-1.472.241,2.676,2.676,0,0,1-1.191-.328.936.936,0,0,1-.568-.7.885.885,0,0,1,.462-.759l-.322-.181.463-.276.323.18a2.9,2.9,0,0,1,1.163-.285,2.95,2.95,0,0,1,1.165.207l-.7.543a1.517,1.517,0,0,0-.905-.063l1.275.712a4.62,4.62,0,0,1,1.595-.317,2.506,2.506,0,0,1,1.144.317,1.09,1.09,0,0,1,.645.765.983.983,0,0,1-.478.858l.609.34-.464.277-.593-.332a3.177,3.177,0,0,1-1.32.3,3.653,3.653,0,0,1-1.435-.292l.743-.549a2.287,2.287,0,0,0,.642.137A2.106,2.106,0,0,0,129.316,181.16Zm-3.424-1.911a.321.321,0,0,0-.079.3.454.454,0,0,0,.234.26,1.063,1.063,0,0,0,.424.118,1.739,1.739,0,0,0,.55-.051Zm3.934,1.66a.387.387,0,0,0,.163-.359.482.482,0,0,0-.275-.328,1.114,1.114,0,0,0-.5-.134,1.832,1.832,0,0,0-.657.111Z",
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-86)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.316,181.16l-1.366-.763a4.037,4.037,0,0,1-1.472.241,2.676,2.676,0,0,1-1.191-.328.936.936,0,0,1-.568-.7.885.885,0,0,1,.462-.759l-.322-.181.463-.276.323.18a2.9,2.9,0,0,1,1.163-.285,2.95,2.95,0,0,1,1.165.207l-.7.543a1.517,1.517,0,0,0-.905-.063l1.275.712a4.62,4.62,0,0,1,1.595-.317,2.506,2.506,0,0,1,1.144.317,1.09,1.09,0,0,1,.645.765.983.983,0,0,1-.478.858l.609.34-.464.277-.593-.332a3.177,3.177,0,0,1-1.32.3,3.653,3.653,0,0,1-1.435-.292l.743-.549a2.287,2.287,0,0,0,.642.137A2.106,2.106,0,0,0,129.316,181.16Zm-3.424-1.911a.321.321,0,0,0-.079.3.454.454,0,0,0,.234.26,1.063,1.063,0,0,0,.424.118,1.739,1.739,0,0,0,.55-.051Zm3.934,1.66a.387.387,0,0,0,.163-.359.482.482,0,0,0-.275-.328,1.114,1.114,0,0,0-.5-.134,1.832,1.832,0,0,0-.657.111Z",
    style: {
      fill: "url(#linear-gradient-85)"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.882,178.152c-.87-1.5-3.186-2.577-5.913-2.577s-5.043,1.076-5.914,2.577h-.374v1.31c0,2.146,2.815,3.886,6.288,3.886s6.287-1.74,6.287-3.886v-1.31Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-87)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.77,179.462v2.185a8.068,8.068,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-86)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.256,178.152c0,2.146-2.815,3.886-6.287,3.886s-6.288-1.74-6.288-3.886,2.815-3.886,6.288-3.886S134.256,176.005,134.256,178.152Z",
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-88)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.77,181.038l9.069-5.343a8.2,8.2,0,0,0-4.853-1.429l-6.305,3.885A3.5,3.5,0,0,0,123.77,181.038Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-89)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.969,182.038c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.029-.361,2.517,2.517,0,0,0-.234-1.039c-2.732,1.6-5.8,3.392-8.068,4.717A9.806,9.806,0,0,0,127.969,182.038Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-88)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.99,177.977c0,1.615-2.248,2.924-5.021,2.924s-5.022-1.309-5.022-2.924,2.248-2.924,5.022-2.924S132.99,176.362,132.99,177.977Z",
    style: {
      fill: "#f9b815"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-90)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.017,180.857l5.876-3.462a3.28,3.28,0,0,0-1.847-1.717,9.839,9.839,0,0,0-2.124-.232l-5.685,3.5A5.046,5.046,0,0,0,127.017,180.857Z",
    style: {
      opacity: 0.5,
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-89)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.969,175.053c-2.774,0-5.022,1.309-5.022,2.924a1.75,1.75,0,0,0,.059.426c.355-1.413,2.438-2.5,4.963-2.5s4.607,1.085,4.962,2.5a1.75,1.75,0,0,0,.059-.426C132.99,176.362,130.742,175.053,127.969,175.053Z",
    style: {
      fill: "#dd7105"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-91)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.977,175.053a8.472,8.472,0,0,0-1.469.128v.853a8.365,8.365,0,0,1,1.469-.129,6.715,6.715,0,0,1,3.979,1.148h0V176.2A6.737,6.737,0,0,0,127.977,175.053Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-90)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.747,179.58a.923.923,0,0,0,.3-.576l.01,0v-.561l-.382-.157a2.025,2.025,0,0,0-.267-.176,2.506,2.506,0,0,0-1.144-.317,4.62,4.62,0,0,0-1.595.317L126.4,177.4a1.516,1.516,0,0,1,.905.062l.7-.542v-.517l-.9.308,0,.008c-.089-.006-.179-.009-.27-.007a2.886,2.886,0,0,0-1.163.286l-.165-.092.063-.049v-.242l-.684-.038v.813l.221-.172.1.056a1.547,1.547,0,0,0-.255.234l-.209-.07,0,.6a.936.936,0,0,0,.568.7,2.662,2.662,0,0,0,1.191.327,4.017,4.017,0,0,0,1.472-.24l1.366.763a2.108,2.108,0,0,1-.587.034,2.277,2.277,0,0,1-.411-.069l.033-.113-1.007.078v.517a3.653,3.653,0,0,0,1.435.292,3.177,3.177,0,0,0,1.32-.3l.593.332.464-.277v-.517Zm-4.244-1.225a1.047,1.047,0,0,1-.424-.119.452.452,0,0,1-.234-.259.323.323,0,0,1,.079-.3l1.129.63A1.713,1.713,0,0,1,126.5,178.355Zm3.355.979-1.272-.71a1.858,1.858,0,0,1,.657-.112,1.127,1.127,0,0,1,.5.135.478.478,0,0,1,.275.328A.387.387,0,0,1,129.858,179.334Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.348,179.068l-1.366-.763a4.017,4.017,0,0,1-1.472.24,2.662,2.662,0,0,1-1.191-.327.936.936,0,0,1-.568-.7.888.888,0,0,1,.462-.76l-.322-.18.463-.276.323.18a2.884,2.884,0,0,1,1.163-.285,2.95,2.95,0,0,1,1.165.207l-.7.542a1.524,1.524,0,0,0-.905-.062l1.275.712a4.62,4.62,0,0,1,1.595-.317,2.506,2.506,0,0,1,1.144.317,1.09,1.09,0,0,1,.645.765.981.981,0,0,1-.479.857l.61.341-.464.277-.593-.332a3.177,3.177,0,0,1-1.32.3,3.653,3.653,0,0,1-1.435-.292l.743-.549a2.285,2.285,0,0,0,.642.136A2.108,2.108,0,0,0,129.348,179.068Zm-3.424-1.912a.323.323,0,0,0-.079.3.452.452,0,0,0,.234.259,1.047,1.047,0,0,0,.424.119,1.713,1.713,0,0,0,.55-.052Zm3.934,1.661a.387.387,0,0,0,.163-.359.48.48,0,0,0-.275-.328,1.127,1.127,0,0,0-.5-.135,1.858,1.858,0,0,0-.657.112Z",
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-92)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.348,179.068l-1.366-.763a4.017,4.017,0,0,1-1.472.24,2.662,2.662,0,0,1-1.191-.327.936.936,0,0,1-.568-.7.888.888,0,0,1,.462-.76l-.322-.18.463-.276.323.18a2.884,2.884,0,0,1,1.163-.285,2.95,2.95,0,0,1,1.165.207l-.7.542a1.524,1.524,0,0,0-.905-.062l1.275.712a4.62,4.62,0,0,1,1.595-.317,2.506,2.506,0,0,1,1.144.317,1.09,1.09,0,0,1,.645.765.981.981,0,0,1-.479.857l.61.341-.464.277-.593-.332a3.177,3.177,0,0,1-1.32.3,3.653,3.653,0,0,1-1.435-.292l.743-.549a2.285,2.285,0,0,0,.642.136A2.108,2.108,0,0,0,129.348,179.068Zm-3.424-1.912a.323.323,0,0,0-.079.3.452.452,0,0,0,.234.259,1.047,1.047,0,0,0,.424.119,1.713,1.713,0,0,0,.55-.052Zm3.934,1.661a.387.387,0,0,0,.163-.359.48.48,0,0,0-.275-.328,1.127,1.127,0,0,0-.5-.135,1.858,1.858,0,0,0-.657.112Z",
    style: {
      fill: "url(#linear-gradient-91)"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.294,195.049c-.87-1.5-3.185-2.577-5.913-2.577s-5.043,1.076-5.914,2.577h-.374v1.31c0,2.146,2.815,3.886,6.288,3.886s6.288-1.74,6.288-3.886v-1.31Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-93)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.182,196.359v2.185a8.072,8.072,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-92)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.669,195.049c0,2.146-2.816,3.886-6.288,3.886s-6.288-1.74-6.288-3.886,2.815-3.886,6.288-3.886S125.669,192.9,125.669,195.049Z",
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-94)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.182,197.935l9.07-5.343a8.206,8.206,0,0,0-4.854-1.429l-6.3,3.885A3.5,3.5,0,0,0,115.182,197.935Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-93)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-95)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.381,198.935c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.03-.361,2.518,2.518,0,0,0-.235-1.039c-2.731,1.6-5.8,3.392-8.068,4.717A9.806,9.806,0,0,0,119.381,198.935Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-94)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.4,194.874c0,1.615-2.248,2.924-5.021,2.924s-5.022-1.309-5.022-2.924,2.249-2.924,5.022-2.924S124.4,193.259,124.4,194.874Z",
    style: {
      fill: "#f9b815"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-96)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.429,197.754l5.876-3.462a3.28,3.28,0,0,0-1.847-1.717,9.832,9.832,0,0,0-2.124-.232l-5.684,3.5A5.042,5.042,0,0,0,118.429,197.754Z",
    style: {
      opacity: 0.5,
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-95)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.381,191.95c-2.773,0-5.022,1.309-5.022,2.924a1.752,1.752,0,0,0,.06.426c.355-1.413,2.438-2.5,4.962-2.5s4.607,1.085,4.962,2.5a1.75,1.75,0,0,0,.059-.426C124.4,193.259,122.154,191.95,119.381,191.95Z",
    style: {
      fill: "#dd7105"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-97)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.389,191.95a8.472,8.472,0,0,0-1.469.128v.853a8.365,8.365,0,0,1,1.469-.129,6.716,6.716,0,0,1,3.98,1.148h0V193.1A6.734,6.734,0,0,0,119.389,191.95Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-96)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122.815,196.28l-.222-.129a.554.554,0,0,0,.24-.394.255.255,0,0,0,0-.039h0v-.483l-.273-.035a1.883,1.883,0,0,0-.416-.331,2.546,2.546,0,0,0-.884-.314,2.28,2.28,0,0,0-.925.036.474.474,0,0,0-.05-.449,1.29,1.29,0,0,0-.472-.431,2.352,2.352,0,0,0-.66-.259,2.747,2.747,0,0,0-.666-.073,1.816,1.816,0,0,0-.51.081l-.577-.337-.069-.285h-.593v.522l.645.376c-.044.023-.089.047-.134.073l-.38.217-.39-.228v-.066l-.791-.294v.522l.28.163-.137-.026v.522l4.706,2.744.5-.285.642.374.54-.308v-.522l-.452.258-.19-.11.169-.1c.126-.072.239-.138.338-.2l.645.376.54-.308v-.523Zm-4.4-.979-1.088-.634.411-.235c.337-.193.547-.307.628-.341a.86.86,0,0,1,.435-.058,1.167,1.167,0,0,1,.446.155.5.5,0,0,1,.262.275.252.252,0,0,1-.121.263q-.085.067-.5.307Zm3.167.514a2.955,2.955,0,0,1-.463.3l-.663.379-1.258-.733.578-.331a2.873,2.873,0,0,1,.7-.323,1.117,1.117,0,0,1,.439,0,1.373,1.373,0,0,1,.437.165.63.63,0,0,1,.3.291A.232.232,0,0,1,121.586,195.815Z",
    style: {
      fill: "#dd7105"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.727,196.33l-.645-.376c-.1.059-.212.125-.338.2l-.169.1.642.375-.54.308-.642-.374-.5.285-4.706-2.744.5-.285-.642-.374.539-.309.642.375.38-.217c.045-.026.09-.05.134-.073l-.645-.376.539-.309.7.408a1.816,1.816,0,0,1,.51-.08,2.7,2.7,0,0,1,.666.073,2.323,2.323,0,0,1,.66.259,1.289,1.289,0,0,1,.472.43.477.477,0,0,1,.05.45,2.28,2.28,0,0,1,.925-.036,2.546,2.546,0,0,1,.884.314,1.8,1.8,0,0,1,.512.428.683.683,0,0,1,.177.46.551.551,0,0,1-.24.393l.674.393Zm-5.4-2.186,1.088.635.469-.268q.418-.24.5-.307a.253.253,0,0,0,.121-.264.5.5,0,0,0-.262-.274,1.15,1.15,0,0,0-.446-.155.849.849,0,0,0-.435.058c-.081.034-.291.148-.628.34Zm1.871,1.091,1.258.734.663-.379a3.036,3.036,0,0,0,.463-.3.233.233,0,0,0,.072-.259.624.624,0,0,0-.3-.29,1.35,1.35,0,0,0-.437-.165,1.137,1.137,0,0,0-.439,0,2.928,2.928,0,0,0-.7.324Z",
    style: {
      fill: "#f9b815"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-98)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.727,196.33l-.645-.376c-.1.059-.212.125-.338.2l-.169.1.642.375-.54.308-.642-.374-.5.285-4.706-2.744.5-.285-.642-.374.539-.309.642.375.38-.217c.045-.026.09-.05.134-.073l-.645-.376.539-.309.7.408a1.816,1.816,0,0,1,.51-.08,2.7,2.7,0,0,1,.666.073,2.323,2.323,0,0,1,.66.259,1.289,1.289,0,0,1,.472.43.477.477,0,0,1,.05.45,2.28,2.28,0,0,1,.925-.036,2.546,2.546,0,0,1,.884.314,1.8,1.8,0,0,1,.512.428.683.683,0,0,1,.177.46.551.551,0,0,1-.24.393l.674.393Zm-5.4-2.186,1.088.635.469-.268q.418-.24.5-.307a.253.253,0,0,0,.121-.264.5.5,0,0,0-.262-.274,1.15,1.15,0,0,0-.446-.155.849.849,0,0,0-.435.058c-.081.034-.291.148-.628.34Zm1.871,1.091,1.258.734.663-.379a3.036,3.036,0,0,0,.463-.3.233.233,0,0,0,.072-.259.624.624,0,0,0-.3-.29,1.35,1.35,0,0,0-.437-.165,1.137,1.137,0,0,0-.439,0,2.928,2.928,0,0,0-.7.324Z",
    style: {
      fill: "url(#linear-gradient-97)"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.294,192.849c-.87-1.5-3.185-2.576-5.913-2.576s-5.043,1.075-5.914,2.576h-.374v1.31c0,2.146,2.815,3.886,6.288,3.886s6.288-1.74,6.288-3.886v-1.31Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-99)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.182,194.159v2.185a8.072,8.072,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-98)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.669,192.849c0,2.146-2.816,3.886-6.288,3.886s-6.288-1.74-6.288-3.886,2.815-3.886,6.288-3.886S125.669,190.7,125.669,192.849Z",
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-100)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.182,195.735l9.07-5.343a8.206,8.206,0,0,0-4.854-1.429l-6.3,3.886A3.5,3.5,0,0,0,115.182,195.735Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-99)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-101)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.381,196.735c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.03-.361,2.521,2.521,0,0,0-.235-1.039c-2.731,1.6-5.8,3.393-8.068,4.718A9.877,9.877,0,0,0,119.381,196.735Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-100)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.4,192.675c0,1.614-2.248,2.923-5.021,2.923s-5.022-1.309-5.022-2.923,2.249-2.924,5.022-2.924S124.4,191.06,124.4,192.675Z",
    style: {
      fill: "#f9b815"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-102)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.429,195.555l5.876-3.462a3.277,3.277,0,0,0-1.847-1.717,9.77,9.77,0,0,0-2.124-.232l-5.684,3.5A5.043,5.043,0,0,0,118.429,195.555Z",
    style: {
      opacity: 0.5,
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-101)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.381,189.751c-2.773,0-5.022,1.309-5.022,2.924a1.737,1.737,0,0,0,.06.425c.355-1.412,2.438-2.5,4.962-2.5s4.607,1.086,4.962,2.5a1.736,1.736,0,0,0,.059-.425C124.4,191.06,122.154,189.751,119.381,189.751Z",
    style: {
      fill: "#dd7105"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-103)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.389,189.751a8.375,8.375,0,0,0-1.469.128v.853a8.363,8.363,0,0,1,1.469-.13,6.716,6.716,0,0,1,3.98,1.149h0V190.9A6.727,6.727,0,0,0,119.389,189.751Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-102)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122.815,194.081l-.222-.13a.551.551,0,0,0,.24-.393.255.255,0,0,0,0-.039h0v-.483L122.56,193a1.88,1.88,0,0,0-.416-.33,2.526,2.526,0,0,0-.884-.314,2.28,2.28,0,0,0-.925.036.477.477,0,0,0-.05-.45,1.289,1.289,0,0,0-.472-.43,2.323,2.323,0,0,0-.66-.259,2.7,2.7,0,0,0-.666-.073,1.816,1.816,0,0,0-.51.08l-.577-.337-.069-.285h-.593v.522l.645.377c-.044.022-.089.047-.134.072l-.38.218-.39-.228v-.066l-.791-.295v.523l.28.163-.137-.026v.522l4.706,2.744.5-.285.642.374.54-.308v-.523l-.452.259-.19-.111.169-.1c.126-.072.239-.137.338-.2l.645.376.54-.309v-.522Zm-4.4-.979-1.088-.635.411-.235c.337-.193.547-.306.628-.341a.849.849,0,0,1,.435-.057,1.15,1.15,0,0,1,.446.155.5.5,0,0,1,.262.274.253.253,0,0,1-.121.264,5.872,5.872,0,0,1-.5.306Zm3.167.513a3.008,3.008,0,0,1-.463.3l-.663.379-1.258-.734.578-.33a2.888,2.888,0,0,1,.7-.324,1.137,1.137,0,0,1,.439,0,1.352,1.352,0,0,1,.437.166.624.624,0,0,1,.3.29A.231.231,0,0,1,121.586,193.615Z",
    style: {
      fill: "#dd7105"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.727,194.13l-.645-.376c-.1.06-.212.125-.338.2l-.169.1.642.374-.54.309-.642-.375-.5.285-4.706-2.743.5-.285-.642-.375.539-.308.642.374.38-.217c.045-.026.09-.05.134-.073l-.645-.376.539-.308.7.408a1.781,1.781,0,0,1,.51-.08,2.651,2.651,0,0,1,.666.073,2.35,2.35,0,0,1,.66.258,1.29,1.29,0,0,1,.472.431.474.474,0,0,1,.05.449,2.316,2.316,0,0,1,.925-.036,2.546,2.546,0,0,1,.884.314,1.807,1.807,0,0,1,.512.429.683.683,0,0,1,.177.46.555.555,0,0,1-.24.393l.674.393Zm-5.4-2.185,1.088.634.469-.268q.418-.24.5-.307a.252.252,0,0,0,.121-.263.5.5,0,0,0-.262-.275,1.167,1.167,0,0,0-.446-.155.86.86,0,0,0-.435.058c-.081.035-.291.148-.628.341Zm1.871,1.091,1.258.734.663-.379a3.008,3.008,0,0,0,.463-.3.232.232,0,0,0,.072-.258.63.63,0,0,0-.3-.291,1.373,1.373,0,0,0-.437-.165,1.117,1.117,0,0,0-.439,0,2.873,2.873,0,0,0-.7.323Z",
    style: {
      fill: "#f9b815"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-104)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.727,194.13l-.645-.376c-.1.06-.212.125-.338.2l-.169.1.642.374-.54.309-.642-.375-.5.285-4.706-2.743.5-.285-.642-.375.539-.308.642.374.38-.217c.045-.026.09-.05.134-.073l-.645-.376.539-.308.7.408a1.781,1.781,0,0,1,.51-.08,2.651,2.651,0,0,1,.666.073,2.35,2.35,0,0,1,.66.258,1.29,1.29,0,0,1,.472.431.474.474,0,0,1,.05.449,2.316,2.316,0,0,1,.925-.036,2.546,2.546,0,0,1,.884.314,1.807,1.807,0,0,1,.512.429.683.683,0,0,1,.177.46.555.555,0,0,1-.24.393l.674.393Zm-5.4-2.185,1.088.634.469-.268q.418-.24.5-.307a.252.252,0,0,0,.121-.263.5.5,0,0,0-.262-.275,1.167,1.167,0,0,0-.446-.155.86.86,0,0,0-.435.058c-.081.035-.291.148-.628.341Zm1.871,1.091,1.258.734.663-.379a3.008,3.008,0,0,0,.463-.3.232.232,0,0,0,.072-.258.63.63,0,0,0-.3-.291,1.373,1.373,0,0,0-.437-.165,1.117,1.117,0,0,0-.439,0,2.873,2.873,0,0,0-.7.323Z",
    style: {
      fill: "url(#linear-gradient-103)"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.294,190.65c-.87-1.5-3.185-2.577-5.913-2.577s-5.043,1.076-5.914,2.577h-.374v1.31c0,2.146,2.815,3.886,6.288,3.886s6.288-1.74,6.288-3.886v-1.31Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-105)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.182,191.96v2.185a8.072,8.072,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-104)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.669,190.65c0,2.146-2.816,3.886-6.288,3.886s-6.288-1.74-6.288-3.886,2.815-3.887,6.288-3.887S125.669,188.5,125.669,190.65Z",
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-106)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.182,193.536l9.07-5.343a8.213,8.213,0,0,0-4.854-1.43l-6.3,3.886A3.5,3.5,0,0,0,115.182,193.536Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-105)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-107)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.381,194.536c.1,0,.19-.007.285-.009l5.973-3.516a2.408,2.408,0,0,0,.03-.361,2.518,2.518,0,0,0-.235-1.039c-2.731,1.6-5.8,3.392-8.068,4.717A9.806,9.806,0,0,0,119.381,194.536Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-106)"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.381,
    cy: 190.475,
    rx: 5.021,
    ry: 2.924,
    style: {
      fill: "#f9b815"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-108)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.429,193.355l5.876-3.462a3.28,3.28,0,0,0-1.847-1.717,9.832,9.832,0,0,0-2.124-.232l-5.684,3.5A5.042,5.042,0,0,0,118.429,193.355Z",
    style: {
      opacity: 0.5,
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-107)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.381,187.551c-2.773,0-5.022,1.309-5.022,2.924a1.752,1.752,0,0,0,.06.426c.355-1.413,2.438-2.5,4.962-2.5s4.607,1.085,4.962,2.5a1.75,1.75,0,0,0,.059-.426C124.4,188.86,122.154,187.551,119.381,187.551Z",
    style: {
      fill: "#dd7105"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-109)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.389,187.551a8.375,8.375,0,0,0-1.469.128v.853a8.365,8.365,0,0,1,1.469-.129,6.716,6.716,0,0,1,3.98,1.148h0V188.7A6.734,6.734,0,0,0,119.389,187.551Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-108)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122.815,191.881l-.222-.129a.554.554,0,0,0,.24-.394.255.255,0,0,0,0-.039h0v-.483l-.273-.035a1.883,1.883,0,0,0-.416-.331,2.546,2.546,0,0,0-.884-.314,2.28,2.28,0,0,0-.925.036.474.474,0,0,0-.05-.449,1.29,1.29,0,0,0-.472-.431,2.352,2.352,0,0,0-.66-.259,2.7,2.7,0,0,0-.666-.073,1.853,1.853,0,0,0-.51.08l-.577-.336-.069-.285h-.593v.522l.645.376c-.044.023-.089.047-.134.073l-.38.217-.39-.228v-.066l-.791-.294v.522l.28.163-.137-.026v.522l4.706,2.744.5-.285.642.374.54-.308v-.522l-.452.258-.19-.11.169-.1c.126-.072.239-.138.338-.2l.645.376.54-.308v-.523Zm-4.4-.979-1.088-.634.411-.235c.337-.193.547-.307.628-.341a.86.86,0,0,1,.435-.058,1.167,1.167,0,0,1,.446.155.5.5,0,0,1,.262.274.252.252,0,0,1-.121.264q-.085.068-.5.307Zm3.167.514a2.955,2.955,0,0,1-.463.3l-.663.379-1.258-.733.578-.331a2.928,2.928,0,0,1,.7-.324,1.137,1.137,0,0,1,.439,0,1.373,1.373,0,0,1,.437.165.625.625,0,0,1,.3.291A.232.232,0,0,1,121.586,191.416Z",
    style: {
      fill: "#dd7105"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.727,191.931l-.645-.376c-.1.059-.212.125-.338.2l-.169.1.642.375-.54.308-.642-.374-.5.285-4.706-2.744.5-.285-.642-.374.539-.309.642.375.38-.217c.045-.026.09-.051.134-.073l-.645-.376.539-.309.7.408a1.816,1.816,0,0,1,.51-.08,2.7,2.7,0,0,1,.666.073,2.323,2.323,0,0,1,.66.259,1.289,1.289,0,0,1,.472.43.477.477,0,0,1,.05.45,2.28,2.28,0,0,1,.925-.036,2.546,2.546,0,0,1,.884.314,1.8,1.8,0,0,1,.512.428.683.683,0,0,1,.177.46.551.551,0,0,1-.24.393l.674.393Zm-5.4-2.186,1.088.635.469-.269a5.872,5.872,0,0,0,.5-.306.253.253,0,0,0,.121-.264.5.5,0,0,0-.262-.274,1.15,1.15,0,0,0-.446-.155.849.849,0,0,0-.435.058c-.081.034-.291.148-.628.34Zm1.871,1.091,1.258.734.663-.379a3.036,3.036,0,0,0,.463-.3.233.233,0,0,0,.072-.259.624.624,0,0,0-.3-.29,1.35,1.35,0,0,0-.437-.165,1.137,1.137,0,0,0-.439,0,2.928,2.928,0,0,0-.7.324Z",
    style: {
      fill: "#f9b815"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-110)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.727,191.931l-.645-.376c-.1.059-.212.125-.338.2l-.169.1.642.375-.54.308-.642-.374-.5.285-4.706-2.744.5-.285-.642-.374.539-.309.642.375.38-.217c.045-.026.09-.051.134-.073l-.645-.376.539-.309.7.408a1.816,1.816,0,0,1,.51-.08,2.7,2.7,0,0,1,.666.073,2.323,2.323,0,0,1,.66.259,1.289,1.289,0,0,1,.472.43.477.477,0,0,1,.05.45,2.28,2.28,0,0,1,.925-.036,2.546,2.546,0,0,1,.884.314,1.8,1.8,0,0,1,.512.428.683.683,0,0,1,.177.46.551.551,0,0,1-.24.393l.674.393Zm-5.4-2.186,1.088.635.469-.269a5.872,5.872,0,0,0,.5-.306.253.253,0,0,0,.121-.264.5.5,0,0,0-.262-.274,1.15,1.15,0,0,0-.446-.155.849.849,0,0,0-.435.058c-.081.034-.291.148-.628.34Zm1.871,1.091,1.258.734.663-.379a3.036,3.036,0,0,0,.463-.3.233.233,0,0,0,.072-.259.624.624,0,0,0-.3-.29,1.35,1.35,0,0,0-.437-.165,1.137,1.137,0,0,0-.439,0,2.928,2.928,0,0,0-.7.324Z",
    style: {
      fill: "url(#linear-gradient-109)"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M137.2,198.282c-.87-1.5-3.186-2.576-5.913-2.576s-5.043,1.075-5.914,2.576H125v1.31c0,2.146,2.815,3.886,6.288,3.886s6.287-1.74,6.287-3.886v-1.31Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-111)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.084,199.592v2.185a8.072,8.072,0,0,0,5.5,1.7v-1.31Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-110)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.57,198.282c0,2.146-2.815,3.886-6.287,3.886S125,200.428,125,198.282s2.815-3.886,6.288-3.886S137.57,196.136,137.57,198.282Z",
    style: {
      fill: "#ffd81d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-112)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.084,201.168l9.069-5.343A8.2,8.2,0,0,0,131.3,194.4L125,198.281A3.5,3.5,0,0,0,127.084,201.168Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-111)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-113)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.283,202.168c.1,0,.19-.006.285-.009l5.973-3.516a2.408,2.408,0,0,0,.029-.361,2.517,2.517,0,0,0-.234-1.039c-2.731,1.6-5.8,3.392-8.068,4.717A9.806,9.806,0,0,0,131.283,202.168Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-112)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.3,198.107c0,1.615-2.248,2.924-5.021,2.924s-5.022-1.309-5.022-2.924,2.249-2.923,5.022-2.923S136.3,196.493,136.3,198.107Z",
    style: {
      fill: "#f9b815"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-114)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.331,200.987l5.876-3.461a3.277,3.277,0,0,0-1.847-1.717,9.838,9.838,0,0,0-2.124-.233l-5.684,3.5A5.042,5.042,0,0,0,130.331,200.987Z",
    style: {
      opacity: 0.5,
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-113)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.283,195.184c-2.773,0-5.022,1.309-5.022,2.923a1.745,1.745,0,0,0,.06.426c.354-1.412,2.438-2.5,4.962-2.5s4.607,1.086,4.962,2.5a1.744,1.744,0,0,0,.059-.426C136.3,196.493,134.056,195.184,131.283,195.184Z",
    style: {
      fill: "#dd7105"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-115)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.291,195.184a8.473,8.473,0,0,0-1.469.127v.854a8.363,8.363,0,0,1,1.469-.13,6.713,6.713,0,0,1,3.979,1.148h0v-.853A6.734,6.734,0,0,0,131.291,195.184Z",
    style: {
      mixBlendMode: "overlay",
      fill: "url(#linear-gradient-114)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M134.44,198.858l0,.03-.395-.19q.148.454-.406.832a1.979,1.979,0,0,1-1.228.283,3.527,3.527,0,0,1-.9-.175l1.316-.9-.024-.572-.607.187.022.071-1.394.952c-.107-.047-.207-.093-.3-.138s-.176-.086-.236-.117l1.554-1.06-.025-.571-.649.129.007.168-1.456.993a1.239,1.239,0,0,1-.433-.48.576.576,0,0,1,.289-.748,1.847,1.847,0,0,1,1.06-.323l-.024-.572-.863-.047,0,.011-.067-.047a3.005,3.005,0,0,0-1.09.456,1.776,1.776,0,0,0-.539.539l-.167-.056.026.559,0,0a1.039,1.039,0,0,0,.06.327,1.747,1.747,0,0,0,.5.685l.023.526.534.365.378-.258c.068.036.148.076.234.118l.014.334.534.364.428-.291a6.1,6.1,0,0,0,1.858.326,3.723,3.723,0,0,0,2.194-.556,1.416,1.416,0,0,0,.612-.724l-.024-.571Z",
    style: {
      fill: "#e06703"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.663,196l.95.655a1.847,1.847,0,0,0-1.06.323.575.575,0,0,0-.289.748,1.231,1.231,0,0,0,.433.48l1.588-1.083.534.365-1.553,1.059c.06.032.138.07.235.117s.195.092.3.138l1.47-1,.534.365-1.316.9a3.477,3.477,0,0,0,.9.175,1.987,1.987,0,0,0,1.228-.282q.554-.378.406-.833l1.237.6a1.414,1.414,0,0,1-.612.723,3.715,3.715,0,0,1-2.194.556,6.1,6.1,0,0,1-1.859-.326l-.427.292-.534-.365.283-.193c-.067-.03-.137-.062-.209-.1-.124-.06-.232-.114-.322-.162l-.378.258-.535-.364.344-.235a2.148,2.148,0,0,1-.864-.977q-.27-.765.619-1.371A2.985,2.985,0,0,1,129.663,196Z",
    style: {
      fill: "#f9b815"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-116)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.663,196l.95.655a1.847,1.847,0,0,0-1.06.323.575.575,0,0,0-.289.748,1.231,1.231,0,0,0,.433.48l1.588-1.083.534.365-1.553,1.059c.06.032.138.07.235.117s.195.092.3.138l1.47-1,.534.365-1.316.9a3.477,3.477,0,0,0,.9.175,1.987,1.987,0,0,0,1.228-.282q.554-.378.406-.833l1.237.6a1.414,1.414,0,0,1-.612.723,3.715,3.715,0,0,1-2.194.556,6.1,6.1,0,0,1-1.859-.326l-.427.292-.534-.365.283-.193c-.067-.03-.137-.062-.209-.1-.124-.06-.232-.114-.322-.162l-.378.258-.534-.364.343-.235a2.148,2.148,0,0,1-.864-.977q-.27-.765.619-1.371A2.985,2.985,0,0,1,129.663,196Z",
    style: {
      fill: "url(#linear-gradient-115)"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "_2-2",
    "data-name": 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.117,82.33s-.829,0-.566.9l-11.1-4.975a2.284,2.284,0,0,0-2.154.293L133.988,93.993c-.962-.325-1.821-.373-2.134.284a1.486,1.486,0,0,0,.383,2.089,1.37,1.37,0,0,0,.383.239l.021.009,11.536,5.162a2.246,2.246,0,0,0,2.118-.29l22.9-16.607A1.538,1.538,0,0,0,169.117,82.33Z",
    style: {
      fill: "url(#linear-gradient-116)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-117)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.117,82.33s-.829,0-.566.9l-11.1-4.975a2.284,2.284,0,0,0-2.154.293L133.988,93.993c-.962-.325-1.821-.373-2.134.284a1.486,1.486,0,0,0,.383,2.089,1.37,1.37,0,0,0,.383.239l.021.009,11.536,5.162a2.246,2.246,0,0,0,2.118-.29l22.9-16.607A1.525,1.525,0,0,0,169.117,82.33Z",
    style: {
      opacity: 0.8,
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-117)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-118)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.123,82.329s-.828,0-.565.9l-11.1-4.975a2.285,2.285,0,0,0-2.154.293L134,93.992c-.963-.325-1.821-.373-2.135.284a1.488,1.488,0,0,0,.383,2.09,1.374,1.374,0,0,0,.384.238l.02.009,11.537,5.163a2.252,2.252,0,0,0,2.118-.29l22.9-16.608A1.546,1.546,0,0,0,169.123,82.329Z",
    style: {
      fill: "#983be9",
      opacity: 0.8,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.162,93.889l22.989-16.656a2.285,2.285,0,0,1,2.153-.292l11.54,5.173a.94.94,0,0,1,.216,1.585l-22.9,16.608a2.25,2.25,0,0,1-2.117.29l-11.537-5.163C131.676,95.052,131.645,94.319,132.162,93.889Z",
    style: {
      fill: "url(#linear-gradient-118)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M137.114,96.612l-.014-.006c-.074-.033-.073-.1,0-.159h0a.3.3,0,0,1,.271-.041l.014.006c.074.033.073.1,0,.159h0A.3.3,0,0,1,137.114,96.612Z",
    style: {
      fill: "#82d6f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1,97.929,137.532,96.8c-.074-.033-.073-.1,0-.159h0a.3.3,0,0,1,.27-.041l2.565,1.132c.074.033.073.1,0,.159h0A.3.3,0,0,1,140.1,97.929Z",
    style: {
      fill: "#82d6f8"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.175,97.066a.16.16,0,0,0-.112.024h0l-1.129.826h0a.291.291,0,0,0-.109.185.229.229,0,0,0,.141.283.161.161,0,0,0,.109-.023h0l.01-.007,1.106-.809h0a.285.285,0,0,0,.124-.195A.229.229,0,0,0,151.175,97.066Z",
    style: {
      fill: "url(#linear-gradient-119)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3,97.14a.158.158,0,0,0-.111.024h0l-1.129.825h0a.287.287,0,0,0-.109.185.228.228,0,0,0,.141.283.162.162,0,0,0,.109-.023h0l.01-.007,1.106-.809h0a.28.28,0,0,0,.124-.194A.229.229,0,0,0,151.3,97.14Z",
    style: {
      fill: "url(#linear-gradient-120)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M152.919,95.817a.161.161,0,0,0-.112.025h0l-1.129.825h0a.3.3,0,0,0-.109.185.229.229,0,0,0,.142.283.149.149,0,0,0,.108-.023h0l.01-.008,1.106-.809h0a.28.28,0,0,0,.124-.2A.23.23,0,0,0,152.919,95.817Z",
    style: {
      fill: "url(#linear-gradient-121)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.047,95.891a.153.153,0,0,0-.111.025h0l-1.129.825h0a.287.287,0,0,0-.109.185.229.229,0,0,0,.141.283.152.152,0,0,0,.109-.023h0l.01-.008,1.106-.809h0a.283.283,0,0,0,.124-.195A.229.229,0,0,0,153.047,95.891Z",
    style: {
      fill: "url(#linear-gradient-122)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.43,98.343a.158.158,0,0,0-.111.025h0l-.276.193h0a.284.284,0,0,0-.109.185.227.227,0,0,0,.141.282.153.153,0,0,0,.109-.023h0L149.2,99l.253-.178h0a.28.28,0,0,0,.124-.195A.23.23,0,0,0,149.43,98.343Z",
    style: {
      fill: "url(#linear-gradient-123)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.559,98.417a.161.161,0,0,0-.112.025h0l-.276.193h0a.292.292,0,0,0-.109.185.228.228,0,0,0,.142.282.149.149,0,0,0,.108-.023h0l.01-.007.254-.178h0a.282.282,0,0,0,.123-.195A.229.229,0,0,0,149.559,98.417Z",
    style: {
      fill: "url(#linear-gradient-124)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M168.11,82.43l-11.169-4.96a1.6,1.6,0,0,0-1.509.2L132.9,94.011c-.362.3-.34.814.241,1.082l2.277,1.01.306-.223a1.446,1.446,0,0,1,1.285-.191l5.042,2.237c.352.156.346.494-.013.756l-.305.222,2.575,1.142a1.574,1.574,0,0,0,1.484-.2l22.465-16.3A.637.637,0,0,0,168.11,82.43Z",
    style: {
      fill: "url(#New_Gradient_Swatch_copy)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M167.909,80.346,156.74,75.385a1.6,1.6,0,0,0-1.509.2L132.7,91.926c-.362.3-.34.815.241,1.083l2.277,1.01.306-.223a1.443,1.443,0,0,1,1.285-.191l5.042,2.237c.352.156.346.494-.013.755l-.305.223,2.575,1.142a1.574,1.574,0,0,0,1.484-.2l22.465-16.3A.637.637,0,0,0,167.909,80.346Z",
    style: {
      fill: "#b4e6fb",
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.909,80.346,156.74,75.385a1.6,1.6,0,0,0-1.509.2L132.7,91.926c-.362.3-.34.815.241,1.083l2.277,1.01.306-.223a1.443,1.443,0,0,1,1.285-.191l5.042,2.237c.352.156.346.494-.013.755l-.305.223,2.575,1.142a1.574,1.574,0,0,0,1.484-.2l22.465-16.3A.637.637,0,0,0,167.909,80.346Z",
    style: {
      fill: "#b4e6fb",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.774,96.415a1.8,1.8,0,0,1-.815-.105l-2.92-1.3.615-.449c.14-.1.184-.2.179-.247s-.089-.1-.125-.117l-5-2.219a1.222,1.222,0,0,0-1.053.165l-.408.3-2.376-1.054a.952.952,0,0,1-.6-.716.814.814,0,0,1,.313-.734l22.359-16.214a1.805,1.805,0,0,1,1.707-.232l11.087,4.924a.856.856,0,0,1,.2,1.488L145.641,96.08A1.779,1.779,0,0,1,144.774,96.415Zm-2.848-1.5,2.2.977a1.329,1.329,0,0,0,1.25-.178l22.287-16.172a.41.41,0,0,0-.1-.713l-.012-.005-11.08-4.921a1.356,1.356,0,0,0-1.275.18L132.851,90.294a.369.369,0,0,0-.143.323.526.526,0,0,0,.345.367l2.138.949.2-.146a1.654,1.654,0,0,1,1.5-.212l5,2.219a.6.6,0,0,1,.388.477A.74.74,0,0,1,141.926,94.92Z",
    style: {
      fill: "#b4e6fb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.774,96.415a1.8,1.8,0,0,1-.815-.105l-2.92-1.3.615-.449c.14-.1.184-.2.179-.247s-.089-.1-.125-.117l-5-2.219a1.222,1.222,0,0,0-1.053.165l-.408.3-2.376-1.054a.952.952,0,0,1-.6-.716.814.814,0,0,1,.313-.734l22.359-16.214a1.805,1.805,0,0,1,1.707-.232l11.087,4.924a.856.856,0,0,1,.2,1.488L145.641,96.08A1.779,1.779,0,0,1,144.774,96.415Zm-2.848-1.5,2.2.977a1.329,1.329,0,0,0,1.25-.178l22.287-16.172a.41.41,0,0,0-.1-.713l-.012-.005-11.08-4.921a1.356,1.356,0,0,0-1.275.18L132.851,90.294a.369.369,0,0,0-.143.323.526.526,0,0,0,.345.367l2.138.949.2-.146a1.654,1.654,0,0,1,1.5-.212l5,2.219a.6.6,0,0,1,.388.477A.74.74,0,0,1,141.926,94.92Z",
    style: {
      fill: "#b4e6fb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.747,96.418a1.794,1.794,0,0,1-.814-.105l-2.92-1.3.615-.449c.14-.1.184-.2.178-.248s-.088-.1-.124-.116l-5-2.22a1.225,1.225,0,0,0-1.053.166l-.408.3-2.377-1.054a.952.952,0,0,1-.6-.717.814.814,0,0,1,.312-.733l22.36-16.215a1.8,1.8,0,0,1,1.707-.231l11.087,4.923a.856.856,0,0,1,.2,1.489L145.615,96.083A1.8,1.8,0,0,1,144.747,96.418Zm-2.847-1.5,2.2.976a1.332,1.332,0,0,0,1.25-.177l22.286-16.173a.408.408,0,0,0-.1-.712l-.012-.005-11.08-4.921a1.356,1.356,0,0,0-1.275.179L132.825,90.3a.368.368,0,0,0-.143.322.527.527,0,0,0,.345.368l2.138.948.2-.145a1.654,1.654,0,0,1,1.5-.213l5,2.219a.6.6,0,0,1,.387.478A.737.737,0,0,1,141.9,94.923Z",
    style: {
      fill: "#b4e6fb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.747,96.418a1.794,1.794,0,0,1-.814-.105l-2.92-1.3.615-.449c.14-.1.184-.2.178-.248s-.088-.1-.124-.116l-5-2.22a1.225,1.225,0,0,0-1.053.166l-.408.3-2.377-1.054a.952.952,0,0,1-.6-.717.814.814,0,0,1,.312-.733l22.36-16.215a1.8,1.8,0,0,1,1.707-.231l11.087,4.923a.856.856,0,0,1,.2,1.489L145.615,96.083A1.8,1.8,0,0,1,144.747,96.418Zm-2.847-1.5,2.2.976a1.332,1.332,0,0,0,1.25-.177l22.286-16.173a.408.408,0,0,0-.1-.712l-.012-.005-11.08-4.921a1.356,1.356,0,0,0-1.275.179L132.825,90.3a.368.368,0,0,0-.143.322.527.527,0,0,0,.345.368l2.138.948.2-.145a1.654,1.654,0,0,1,1.5-.213l5,2.219a.6.6,0,0,1,.387.478A.737.737,0,0,1,141.9,94.923Z",
    style: {
      fill: "#b4e6fb"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "147.809 90.808 148.362 86.051 149.977 86.771 149.68 88.997 154.724 87.827 156.772 88.729 147.809 90.808",
    style: {
      fill: "url(#linear-gradient-125)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "147.741 90.161 148.294 85.404 149.909 86.124 149.612 88.35 154.656 87.18 156.704 88.082 147.741 90.161",
    style: {
      fill: "url(#linear-gradient-126)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_10",
    "data-name": 10
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.708,21.14c1.134-.872,1.032.073.674,1.176l19.61-7.773a2.6,2.6,0,0,1,2.509.533l24.153,20.782c1.145-.325,2.154-.316,2.487.521.6,1.519-.043,2.171-.561,2.552a1.542,1.542,0,0,1-.462.264l-.025.01-20.135,7.97a2.557,2.557,0,0,1-2.467-.526L64.539,24.3S62.535,22.81,64.708,21.14Z",
    style: {
      fill: "url(#linear-gradient-127)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-119)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.708,21.14c1.134-.872,1.032.073.674,1.176l19.61-7.773a2.6,2.6,0,0,1,2.509.533l24.153,20.782c1.145-.325,2.154-.316,2.487.521.6,1.519-.043,2.171-.561,2.552a1.542,1.542,0,0,1-.462.264l-.025.01-20.135,7.97a2.557,2.557,0,0,1-2.467-.526L64.539,24.3S62.535,22.81,64.708,21.14Z",
    style: {
      opacity: 0.8,
      mixBlendMode: "multiply",
      fill: "url(#linear-gradient-128)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-119)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.708,21.14c1.134-.872,1.032.073.674,1.176l19.61-7.773a2.6,2.6,0,0,1,2.509.533l24.153,20.782c1.145-.325,2.154-.316,2.487.521.6,1.519-.043,2.171-.561,2.552a1.542,1.542,0,0,1-.462.264l-.025.01-20.135,7.97a2.557,2.557,0,0,1-2.467-.526L64.539,24.3S62.535,22.81,64.708,21.14Z",
    style: {
      fill: "#983be9",
      opacity: 0.8,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.8,35.875,87.748,13.458a2.6,2.6,0,0,0-2.509-.533L65.1,20.908a1.146,1.146,0,0,0-.338,1.943L90.713,45.2a2.556,2.556,0,0,0,2.467.527l20.135-7.97A1.1,1.1,0,0,0,113.8,35.875Z",
    style: {
      fill: "url(#linear-gradient-129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.465,35.98,91.139,44.229a.47.47,0,0,1-.45-.1L66.011,22.99a.171.171,0,0,1,.049-.29l21.316-8.357a.421.421,0,0,1,.409.086l24.727,21.285A.156.156,0,0,1,112.465,35.98Z",
    style: {
      fill: "url(#linear-gradient-130)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5,35.934,87.774,14.649a.422.422,0,0,0-.409-.087L66.049,22.919A.16.16,0,0,0,66,22.95a.17.17,0,0,1,.081-.255l21.316-8.357a.422.422,0,0,1,.409.087L112.53,35.709a.159.159,0,0,1-.009.247A.2.2,0,0,0,112.5,35.934Z",
    style: {
      fill: "url(#linear-gradient-131)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.808,40.493l.014-.005c.07-.028.072-.1,0-.156h0a.272.272,0,0,0-.25-.057l-.013.005c-.07.027-.072.1,0,.156h0A.275.275,0,0,0,103.808,40.493Z",
    style: {
      fill: "#82d6f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.979,41.6l2.432-.948c.07-.027.072-.1,0-.156h0a.272.272,0,0,0-.25-.057l-2.433.948c-.07.028-.072.1,0,.157h0A.275.275,0,0,0,100.979,41.6Z",
    style: {
      fill: "#82d6f8"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.6,18.441l1.5-.575c.3-.119.3-.416.013-.663h0a1.162,1.162,0,0,0-1.062-.232l-1.5.575c-.3.119-.3.416-.013.663h0A1.162,1.162,0,0,0,75.6,18.441Z",
    style: {
      fill: "#82d6f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.125,17.453a1.163,1.163,0,0,0-1.062-.232l-1.5.575a.348.348,0,0,0-.2.185.306.306,0,0,1,.193-.435l1.495-.575a1.161,1.161,0,0,1,1.062.232h0c.187.159.25.339.193.478A.673.673,0,0,0,77.125,17.453Z",
    style: {
      fill: "#009fe3"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.81,41.547a.145.145,0,0,1,.107.032h0l1.058.918h0a.3.3,0,0,1,.1.2c.018.142-.049.267-.15.279a.149.149,0,0,1-.1-.03h0l-.009-.008-1.037-.9h0a.3.3,0,0,1-.111-.208C85.643,41.684,85.71,41.558,85.81,41.547Z",
    style: {
      fill: "url(#linear-gradient-132)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.682,41.614a.143.143,0,0,1,.107.032h0l1.058.918h0a.309.309,0,0,1,.1.2c.018.142-.049.267-.149.279a.146.146,0,0,1-.105-.03h0L86.68,43l-1.037-.9h0a.3.3,0,0,1-.112-.208C85.515,41.751,85.582,41.626,85.682,41.614Z",
    style: {
      fill: "url(#linear-gradient-133)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.174,40.155a.151.151,0,0,1,.107.032h0l1.058.918h0a.307.307,0,0,1,.1.2c.017.143-.05.268-.15.28a.15.15,0,0,1-.1-.031h0l-.009-.008-1.037-.9h0a.3.3,0,0,1-.111-.207C84.007,40.292,84.074,40.167,84.174,40.155Z",
    style: {
      fill: "url(#linear-gradient-134)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.047,40.222a.154.154,0,0,1,.107.032h0l1.057.918h0a.307.307,0,0,1,.1.2c.017.143-.049.268-.15.28a.145.145,0,0,1-.1-.031h0l-.009-.008-1.037-.9h0A.3.3,0,0,1,83.9,40.5C83.879,40.359,83.946,40.234,84.047,40.222Z",
    style: {
      fill: "url(#linear-gradient-135)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.444,42.967a.151.151,0,0,1,.107.032h0l.259.216h0a.307.307,0,0,1,.1.2c.017.143-.05.268-.15.28a.149.149,0,0,1-.1-.031h0l-.009-.008-.238-.2h0a.3.3,0,0,1-.112-.207C87.277,43.1,87.344,42.979,87.444,42.967Z",
    style: {
      fill: "url(#linear-gradient-136)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.316,43.034a.151.151,0,0,1,.107.032h0l.259.216h0a.307.307,0,0,1,.1.2c.017.143-.05.268-.15.28a.15.15,0,0,1-.1-.031h0l-.009-.008-.238-.2h0a.3.3,0,0,1-.111-.207C87.149,43.171,87.216,43.046,87.316,43.034Z",
    style: {
      fill: "url(#linear-gradient-137)"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.5,45.878c-.058.243.056.4.255.339a.788.788,0,0,0,.465-.543c.058-.244-.057-.395-.256-.339A.785.785,0,0,0,94.5,45.878Z",
    style: {
      fill: "url(#linear-gradient-138)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.606,46.3a.327.327,0,0,0,.169-.006.86.86,0,0,0,.519-.6.4.4,0,0,0-.067-.377.274.274,0,0,0-.285-.062.86.86,0,0,0-.519.6h0a.407.407,0,0,0,.067.378A.254.254,0,0,0,94.606,46.3Zm.471-.893a.1.1,0,0,1,.043.024.25.25,0,0,1,.024.22.712.712,0,0,1-.411.485.135.135,0,0,1-.135-.02.247.247,0,0,1-.024-.219h0a.712.712,0,0,1,.411-.485A.178.178,0,0,1,95.077,45.409Z",
    style: {
      fill: "#e7e1ff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M112.806,33.606l-21.327,8.25a.469.469,0,0,1-.449-.1L66.351,20.616a.171.171,0,0,1,.05-.29l21.316-8.357a.422.422,0,0,1,.409.087L112.853,33.34A.157.157,0,0,1,112.806,33.606Z",
    style: {
      fill: "#b4e6fb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.519,39.372a.673.673,0,0,0,.324-.021L113.177,31.1a.383.383,0,0,0,.248-.3.417.417,0,0,0-.134-.385L88.563,9.13A.641.641,0,0,0,87.939,9L66.611,17.36a.389.389,0,0,0-.25.308.43.43,0,0,0,.14.4l24.68,21.144A.707.707,0,0,0,91.519,39.372Zm21.368-8.682-21.2,8.2a.24.24,0,0,1-.222-.055L66.886,17.774,88.094,9.459a.2.2,0,0,1,.181.045Z",
    style: {
      fill: "#b4e6fb",
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "93.759 33.411 93.155 24.3 90.184 25.471 90.535 29.739 81.539 26.899 77.774 28.364 93.759 33.411",
    style: {
      fill: "url(#linear-gradient-139)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "93.921 32.286 93.316 23.175 90.346 24.347 90.697 28.615 81.701 25.775 77.935 27.239 93.921 32.286",
    style: {
      fill: "url(#linear-gradient-140)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_18",
    "data-name": 18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.021,92.46l0,0,2.422-2.52-3.519-5.714-4.621-15.981c-.778-2.69-3.318-5.343-5.672-5.924L87.093,58.24l-6.1-3.6-2.391,2.487a1.814,1.814,0,0,0-.161.167l-.037.039v0a3.483,3.483,0,0,0-.313,3.2l6.062,20.965c.778,2.691,3.318,5.343,5.673,5.925l22.684,5.6A2.392,2.392,0,0,0,115.021,92.46Z",
    style: {
      fill: "#983be9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.067,90.379l-22.685-5.6c-2.354-.581-4.894-3.233-5.672-5.924L80.648,57.887c-.778-2.69.5-4.4,2.855-3.818l22.684,5.6c2.355.581,4.895,3.234,5.673,5.924l6.062,20.965C118.7,89.251,117.422,90.96,115.067,90.379Z",
    style: {
      fill: "#b45ef4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.648,84.036c-1.5-2.595-4.234-6.488-7.512-7.3l-1.653-.409-.738-1.8a2.279,2.279,0,0,0,.613-1.932h0l-.334-4.661c0-.114-.012-.229-.026-.349l-.006-.092h-.007a5.546,5.546,0,0,0-.173-.841,10.788,10.788,0,0,0-7.037-6.765c-3.021-.746-4.77,1.073-3.905,4.063a7.1,7.1,0,0,0,.311.847h-.007l.051.105q.1.233.224.463l2.493,5.154h0a8.54,8.54,0,0,0,1.911,2.555l.269,1.684-1.636-.4c-3.286-.811-4.022,2.224-4.138,4.42a3.14,3.14,0,0,0,2.268,2.636l8.851,2.185.384.095,8.821,2.179C112.843,86.159,113.336,85.227,112.648,84.036Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.484,61.228a10.788,10.788,0,0,1,7.037,6.765,5.817,5.817,0,0,1,.173.84l.006,0,.007.092c.013.119.021.235.025.349l.334,4.661h0a2.277,2.277,0,0,1-.613,1.933l.738,1.8,1.653.408c3.278.81,6.013,4.7,7.512,7.3a2.687,2.687,0,0,1,.212.464l.1.025c1.171.29,1.664-.642.976-1.833-1.5-2.595-4.234-6.488-7.512-7.3l-1.653-.408-.738-1.8a2.276,2.276,0,0,0,.613-1.932h0l-.334-4.661c0-.114-.012-.229-.025-.349l-.007-.092-.006,0a5.817,5.817,0,0,0-.173-.84,10.788,10.788,0,0,0-7.037-6.765c-1.975-.488-3.4.125-3.913,1.44A4.094,4.094,0,0,1,94.484,61.228Z",
    style: {
      fill: "#721bd5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2,75.694l1.635.4,1.292-1.339c-.021-.019-1.6-.386-1.62-.405l-.015,0a2.743,2.743,0,0,0-3.476,1.465A3.176,3.176,0,0,1,94.2,75.694Z",
    style: {
      fill: "url(#linear-gradient-141)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_14",
    "data-name": 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.832,21.184h0l-1.4-2.218-5.032,4-5.933.263a6.413,6.413,0,0,0-4.837,3.194L177.118,35.1l-7.031,5.583,1.319,2.077a1.315,1.315,0,0,0,.128.2l.009.015h0a1.984,1.984,0,0,0,1.721.626l11.987-.531a6.41,6.41,0,0,0,4.837-3.193l4.19-8.063,5.1-.226s.68-2.45-.319-4l.427.674-1.846-2.921,1.043-2.006A2.176,2.176,0,0,0,198.832,21.184Z",
    style: {
      fill: "#983be9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.805,21.948l-8.6,16.543c-.876,1.684-.13,2.985,1.666,2.905l11.987-.531a6.41,6.41,0,0,0,4.837-3.193l4.19-8.063,5.1-.226s1.292-4.641-2.286-5.193l1.591-3.061c.876-1.684.13-2.985-1.666-2.906l-11.988.531A6.411,6.411,0,0,0,178.805,21.948Z",
    style: {
      fill: "#b45ef4"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M181.731,33.2c1.286-.057,1.82.874,1.193,2.08a4.589,4.589,0,0,1-3.462,2.286c-1.286.057-1.82-.874-1.193-2.08A4.589,4.589,0,0,1,181.731,33.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.744,27.4c1.285-.057,1.819.874,1.193,2.08a4.59,4.59,0,0,1-3.463,2.287c-1.285.056-1.819-.875-1.193-2.081A4.589,4.589,0,0,1,184.744,27.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.756,21.606c1.286-.057,1.82.875,1.193,2.08a4.59,4.59,0,0,1-3.462,2.287c-1.286.057-1.82-.875-1.193-2.08A4.59,4.59,0,0,1,187.756,21.606Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "192.887 29.609 194.279 31.813 199.382 31.587 197.99 29.383 192.887 29.609",
    style: {
      fill: "#721bd5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "_11",
    "data-name": 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.9,39.4l0,0-2.332-1.831-4.527,3.454-13.1,5.253a7.729,7.729,0,0,0-4.522,5.289l-2.049,14.312-2.522,5.451,2.3,1.808a1.532,1.532,0,0,0,.155.121l.036.029v0a2.957,2.957,0,0,0,2.732-.007l17.186-6.891a7.728,7.728,0,0,0,4.522-5.29L159.6,41.463A2.029,2.029,0,0,0,158.9,39.4Z",
    style: {
      fill: "#983be9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.141,39.534,154.33,59.159a7.725,7.725,0,0,1-4.521,5.289L132.622,71.34c-2.205.884-3.757-.05-3.465-2.087l2.811-19.625a7.728,7.728,0,0,1,4.522-5.29l17.186-6.891C155.881,36.562,157.433,37.5,157.141,39.534Z",
    style: {
      fill: "#b45ef4"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M153.546,50.225c-.876,6.113-6.252,12.958-11.985,15.256s-9.684-.8-8.809-6.919S139,45.6,144.737,43.305,154.421,44.11,153.546,50.225Zm-18.515,7.423c-.683,4.774,2.4,7.2,6.878,5.4a16.768,16.768,0,0,0,9.358-11.913c.683-4.773-2.4-7.2-6.878-5.4A16.77,16.77,0,0,0,135.031,57.648Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.957 52.032 142.469 56.09 138.244 52.504 140.132 50.164 143.345 52.891 146.177 50.331 146.957 52.032",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.255,
    cy: 203.19,
    rx: 6.055,
    ry: 3.496,
    transform: "translate(-62.14 78.113) rotate(-21.438)",
    style: {
      fill: "#00233b",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M175.105,184.819l1.238-.753a.469.469,0,0,1,.091-.055l.02-.013,0,0a.461.461,0,0,1,.416.031l4.319,2.6a1.248,1.248,0,0,1,.591,1.071v3.977a.509.509,0,0,1-.2.407v0l-.024.014c-.014.01-.51.375-.525.383l-.812.44-1.311-2.076-2.174-1.293a1.248,1.248,0,0,1-.6-1.075v-2.025Z",
    style: {
      fill: "#007bbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.76,192.922l-4.315-2.566a1.248,1.248,0,0,1-.6-1.075v-4.012a.489.489,0,0,1,.731-.444l4.319,2.6a1.248,1.248,0,0,1,.591,1.071v3.977A.489.489,0,0,1,179.76,192.922Z",
    style: {
      fill: "#005b9a"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.985,180.756s-1.732-.5-1.127-1.454c.185-.29-.338-.566-.171-.728.127-.123.883.55.962.584a1.654,1.654,0,0,1,.85,1.272l1.4.7,1.386.948-.192.518a.806.806,0,0,1-1.318.3l-.719-.7Z",
    style: {
      fill: "#ffdcc0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178.556,201.13a2.937,2.937,0,0,1-1.821-.2c-.355.01-1.942-.792-2.205-.1-.23.609.606,1.171,1.053,1.28.975.236,1.7.722,2.089.8a.988.988,0,0,0,.9-.128A1.76,1.76,0,0,0,178.556,201.13Z",
    style: {
      fill: "#005b9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.672,202.745c-.392-.082-1.114-.569-2.089-.805-.374-.091-1.019-.5-1.085-.989-.086.56.668,1.057,1.085,1.158.975.236,1.7.722,2.089.8a.988.988,0,0,0,.9-.128.561.561,0,0,0,.128-.233A1.166,1.166,0,0,1,177.672,202.745Z",
    style: {
      fill: "#005b9a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.672,202.745c-.392-.082-1.114-.569-2.089-.805-.374-.091-1.019-.5-1.085-.989-.086.56.668,1.057,1.085,1.158.975.236,1.7.722,2.089.8a.988.988,0,0,0,.9-.128.561.561,0,0,0,.128-.233A1.166,1.166,0,0,1,177.672,202.745Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M175.547,200.61a.93.93,0,0,0-.47.555c-.023.109.145.156.168.046a.753.753,0,0,1,.551-.538A.229.229,0,0,0,175.547,200.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M174.867,204.265c-.426-.09-1.212-.62-2.275-.877-.408-.1-1.111-.546-1.182-1.078-.094.61.728,1.151,1.182,1.261,1.063.257,1.849.787,2.275.877a1.08,1.08,0,0,0,.984-.139.636.636,0,0,0,.139-.254A1.271,1.271,0,0,1,174.867,204.265Z",
    style: {
      fill: "#005b9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.831,202.505a3.19,3.19,0,0,1-1.984-.222c-.387.012-2.116-.862-2.4-.106-.251.663.66,1.276,1.147,1.394,1.063.257,1.849.787,2.275.877a1.08,1.08,0,0,0,.984-.139A1.921,1.921,0,0,0,175.831,202.505Z",
    style: {
      fill: "#005b9a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.867,204.265c-.426-.09-1.212-.62-2.275-.877-.408-.1-1.111-.546-1.182-1.078-.094.61.728,1.151,1.182,1.261,1.063.257,1.849.787,2.275.877a1.08,1.08,0,0,0,.984-.139.636.636,0,0,0,.139-.254A1.271,1.271,0,0,1,174.867,204.265Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M180.611,182.118s-.27,4.764-1.512,4.075c-.495-.274.074-4.345.074-4.345Z",
    style: {
      fill: "#ffdcc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.326,176.735l1.652-.094c.071,0-.015-.074-.015-.145l.145-.763a.13.13,0,0,0-.13-.129L176.757,175a4.508,4.508,0,0,0-.9.735l.29.771C176.145,176.575,176.254,176.735,176.326,176.735Z",
    style: {
      fill: "#ffdcc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.029,174.072c-.095,1.152.28,2.327.89,1.8.836-.718,1.682-.759,1.682-1.915s-.178-1.979-.981-1.979S175.162,172.457,175.029,174.072Z",
    style: {
      fill: "#ffdcc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.043,172.119a1.524,1.524,0,0,0,.074.7c.3.3,1.043.721.814,1.255-.2.464.029-.008.426-.424.144-.149.218.049.276.248a1.078,1.078,0,0,1-.325,1.1c-.565.565,1.046.735,1.8.735s2.531-3.163-.011-4.481C175.979,170.154,175.233,171.6,175.043,172.119Z",
    style: {
      fill: "#2db9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.083,186.176s.523,3.121,0,4.552c-.752,2.055-.314,11.408-.314,11.408s-1.651,1.124-1.908-2.25-.358-9.743-.358-9.743l-.415.186a117.23,117.23,0,0,0-.22,12.824c.056.722-1.68.863-1.983-1.44S173.4,187.3,173.4,187.3,177.361,185.319,179.083,186.176Z",
    style: {
      fill: "#05adf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.831,176.263h0l-2.177.36A5.414,5.414,0,0,0,173.4,178.9l-.622,1.44-.617.7a.3.3,0,0,0-.345.383c.042.291.377.106.975,1.3.218.435.652-.138.908-.552l.486-.788-.777,6.077s5.441,2.88,6.322-.577l.192-4.639.756.166s.433-.694-.566-3.945C179.786,177.4,178.775,175.988,177.831,176.263Z",
    style: {
      fill: "#005b9a"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.746,
    cy: 194.008,
    rx: 3.496,
    ry: 6.055,
    transform: "translate(-129.987 197.327) rotate(-68.562)",
    style: {
      fill: "#00233b",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79.9,175.638l-1.237-.753a.507.507,0,0,0-.091-.056l-.021-.012,0,0a.46.46,0,0,0-.416.031l-4.319,2.6a1.246,1.246,0,0,0-.591,1.071V182.5a.508.508,0,0,0,.2.407v0l.024.014c.014.01.51.375.525.383l.813.44,1.31-2.076,2.175-1.294a1.249,1.249,0,0,0,.6-1.075v-2.024Z",
    style: {
      fill: "#007bbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.24,183.741l4.316-2.566a1.248,1.248,0,0,0,.6-1.075v-4.012a.488.488,0,0,0-.731-.444l-4.319,2.6a1.246,1.246,0,0,0-.591,1.071V183.3A.488.488,0,0,0,75.24,183.741Z",
    style: {
      fill: "#005b9a"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.016,171.575s1.732-.5,1.126-1.454c-.184-.291.339-.566.171-.729-.126-.122-.882.551-.961.585a1.657,1.657,0,0,0-.851,1.272l-1.4.695-1.385.949.191.518a.806.806,0,0,0,1.318.3l.719-.7Z",
    style: {
      fill: "#ffdcc0"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.444,191.949a2.937,2.937,0,0,0,1.821-.2c.356.011,1.943-.791,2.2-.1.23.608-.606,1.171-1.053,1.279-.975.237-1.7.723-2.088.805a.99.99,0,0,1-.9-.127A1.76,1.76,0,0,1,76.444,191.949Z",
    style: {
      fill: "#005b9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.329,193.564c.391-.082,1.113-.569,2.088-.805.375-.091,1.02-.5,1.085-.989.087.56-.668,1.056-1.085,1.157-.975.237-1.7.723-2.088.805a.99.99,0,0,1-.9-.127.572.572,0,0,1-.128-.233A1.171,1.171,0,0,0,77.329,193.564Z",
    style: {
      fill: "#005b9a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.329,193.564c.391-.082,1.113-.569,2.088-.805.375-.091,1.02-.5,1.085-.989.087.56-.668,1.056-1.085,1.157-.975.237-1.7.723-2.088.805a.99.99,0,0,1-.9-.127.572.572,0,0,1-.128-.233A1.171,1.171,0,0,0,77.329,193.564Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M79.453,191.429a.93.93,0,0,1,.47.555c.023.109-.145.156-.168.046a.75.75,0,0,0-.55-.538A.227.227,0,0,1,79.453,191.429Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80.133,195.083c.427-.089,1.213-.619,2.275-.877.408-.1,1.111-.545,1.182-1.077.095.61-.728,1.151-1.182,1.261-1.062.257-1.848.787-2.275.877a1.078,1.078,0,0,1-.983-.139.613.613,0,0,1-.139-.254A1.272,1.272,0,0,0,80.133,195.083Z",
    style: {
      fill: "#005b9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.17,193.324a3.2,3.2,0,0,0,1.983-.222c.388.012,2.116-.862,2.4-.106.25.663-.661,1.276-1.148,1.394-1.062.257-1.848.787-2.275.877a1.078,1.078,0,0,1-.983-.139A1.915,1.915,0,0,1,79.17,193.324Z",
    style: {
      fill: "#005b9a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.133,195.083c.427-.089,1.213-.619,2.275-.877.408-.1,1.111-.545,1.182-1.077.095.61-.728,1.151-1.182,1.261-1.062.257-1.848.787-2.275.877a1.078,1.078,0,0,1-.983-.139.613.613,0,0,1-.139-.254A1.272,1.272,0,0,0,80.133,195.083Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M74.39,172.937s.269,4.764,1.511,4.075c.5-.274-.073-4.345-.073-4.345Z",
    style: {
      fill: "#ffdcc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.675,167.554l-1.653-.095c-.071,0,.015-.073.015-.144l-.144-.763a.129.129,0,0,1,.129-.129l1.222-.606a4.536,4.536,0,0,1,.9.735l-.291.77C78.855,167.394,78.746,167.554,78.675,167.554Z",
    style: {
      fill: "#ffdcc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.971,164.891c.095,1.152-.28,2.327-.89,1.8-.836-.717-1.681-.758-1.681-1.914s.177-1.979.981-1.979S79.838,163.276,79.971,164.891Z",
    style: {
      fill: "#ffdcc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.957,162.937a1.5,1.5,0,0,1-.074.7c-.3.3-1.042.721-.813,1.255.2.464-.03-.009-.427-.424-.143-.149-.217.049-.276.247a1.081,1.081,0,0,0,.326,1.1c.565.565-1.047.735-1.8.735s-2.531-3.163.011-4.481C79.021,160.973,79.767,162.422,79.957,162.937Z",
    style: {
      fill: "#2db9f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.918,177s-.524,3.121,0,4.552c.751,2.055.314,11.407.314,11.407s1.651,1.125,1.908-2.249.358-9.744.358-9.744l.415.187a117.5,117.5,0,0,1,.22,12.824c-.057.722,1.679.862,1.982-1.441s.486-14.411.486-14.411S77.639,176.138,75.918,177Z",
    style: {
      fill: "#05adf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.17,167.082h0l2.177.36a5.414,5.414,0,0,1,2.254,2.276l.622,1.44.616.7a.3.3,0,0,1,.346.383c-.042.291-.377.106-.975,1.295-.219.434-.653-.139-.908-.552l-.487-.789.777,6.077s-5.441,2.881-6.322-.576l-.191-4.64-.757.166s-.433-.693.566-3.944C75.214,168.216,76.226,166.807,77.17,167.082Z",
    style: {
      fill: "#005b9a"
    }
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualifiedLeadBanner);
export default __webpack_public_path__ + "static/media/qualified_lead_banner.3686781a42078c6dfaf9a9e1c97216ac.svg";
export { ForwardRef as ReactComponent };